/* eslint-disable no-useless-escape */
/* eslint-disable react/prop-types */
/* eslint-disable no-case-declarations */
/* eslint-disable no-console */
import React from "react";
import "../../assets/styles/App.css";
import { Button, FormGroup, FormControl } from "react-bootstrap";
import { toast } from "react-toastify";
import { createPatientExam, getAbhaCard } from "../../constants/endpoints";
import {
  postAuthenticatedData,
  postAuthenticatedABDMData,
  getAuthenticatedData
} from "../../utils/async";
import DatePicker from "react-datepicker";
import subYears from "date-fns/subYears";
import differenceInYears from "date-fns/differenceInYears";
import { withTranslation } from "react-i18next";
import "react-datepicker/dist/react-datepicker.css";
import {
  T_ENTITIES,
  T_EXAMS,
  T_GENERAL,
  T_PATIENTS
} from "../../constants/translations";
import { registerLocale } from "react-datepicker";
import it from "date-fns/locale/it";
registerLocale("it", it);
import { abdmM1URL, abdmM1PHRURL } from "../../config";
import { Stepper } from "react-form-stepper";
import OtpInput from "react-otp-input";
import { Table } from "reactstrap";
import { convertEpochToTime, getShortMonth } from "../../utils/date";

/**
 * This is the component for the Add Exam / Patient modal on the Exam Data page <br>
 * It uses the React Datepicker module for generating a Date Picker <br>
 * It also uses the date-fns module for convenient date calculation <br>
 * It takes a prop named `device` which contains the device type selected in the parent component. <br>
 * SRS IDs: <br>
 * AIM - 5.3.14.3 <br>
 * PSL - 5.3.14.3 <br>
 * FOP - 5.3.14.3 <br>
 *
 * @component
 */
class CustomAddExamPatientModal extends React.Component {
  constructor(props) {
    super(props);

    this.t = props.t;
    this.i18n = props.i18n;

    this.modal = React.createRef();

    let customFields = [];
    let customFieldValues = {};

    // Get custom fields for the initial site (this.props.currentSite)
    if (this.props.sites && this.props.currentSite) {
      const currentSite = this.props.sites.find(
        site => site.siteId.toString() === this.props.currentSite.toString()
      );

      if (
        currentSite &&
        currentSite.configurations &&
        currentSite.configurations.CUSTOM_FIELDS &&
        currentSite.configurations.CUSTOM_FIELDS.length > 0
      ) {
        try {
          const customFieldsValue =
            currentSite.configurations.CUSTOM_FIELDS[0].value;
          customFields = JSON.parse(customFieldsValue);

          // Initialize custom field values
          customFields.forEach(field => {
            customFieldValues[field.id] =
              field.type === "picker"
                ? ""
                : field.type === "number"
                ? ""
                : field.type === "date"
                ? null
                : "";
          });
        } catch (error) {
          console.error("Error parsing custom fields for initial site:", error);
          customFields = [];
          customFieldValues = {};
        }
      }
    }

    this.state = {
      isLoaded: true,
      disableFirstButton: true,
      disableSecondButton: true,
      startDate: undefined,
      editDeviceType: [this.props.device],
      mrn: "",
      firstname: "",
      lastname: "",
      gender: "MALE",
      examCustomId: "",
      doctorfirstname: "",
      doctorlastname: "",
      doctoremail: "",
      medicalhistory: "",
      ocularhistory: "",
      currentmedication: "",
      allergies: "",
      leftucva: "",
      rightucva: "",
      leftsph: "",
      rightsph: "",
      leftcyl: "",
      rightcyl: "",
      leftaxis: "",
      rightaxis: "",
      leftbcva: "",
      rightbcva: "",
      leftadd: "",
      rightadd: "",
      leftiop: "",
      rightiop: "",
      leftpg: "",
      rightpg: "",
      collapsed: false,
      site: this.props.currentSite,
      currentPage: 1,
      aadhaarNumber: "",
      consent: false,
      disableConsentButton: true,
      otp: "",
      disableOtpButton: true,
      txnId: "",
      abhaAddress: "",
      phoneNumber: "",
      disableButton: false,
      address: "",
      publicKeyPem: "",
      disableProfileButton: false,
      abhaAddressList: [],
      disableAbhaAddressButton: false,
      token: "",
      abhaImage: "",
      timeLeft: 60,
      isFinished: false,
      abhaNumber: "",
      abdm: false,
      disableVerifyButton: false,
      selectedAccountVerify: -1,
      disableSubmitAccountVerifyButton: true,
      accountsVerify: [],
      verifyToken: "",
      scanAccounts: [],
      method: "phoneNumber",
      hasResent: false,
      hasResent2: false,
      hasResentVerify: false,
      resendCount: 0,
      resendCount2: 0,
      resendCountVerify: 0,
      consents: {
        consent1: false,
        consent2: false,
        consent3: false,
        consent4: false,
        consent5: false,
        consent6: false
      },
      abhaAddressValidation: {
        minLength: false,
        maxLength: false,
        onlyAllowedChars: false,
        noSpecialStartEnd: true,
        singleDot: true,
        singleUnderscore: false,
        isValid: false
      },
      maskedAadhaar: "",
      linkingFlow: false,
      districtName: "",
      pinCode: "",
      stateName: "",
      couldBeUnlinked: false,
      authModes: [],
      authModesFetched: false,
      customFields: customFields,
      customFieldValues: customFieldValues,
      originalPatientData: null,
      newPatientData: {},
      showComparison: false,
      shouldCheckExisting: false,
      abhaCardAvailable: false, // Add this new state
      abhaCardError: false, // Add this to track errors
      abhaCardErrorMessage: "",
      checksum: ""
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onFirstPageProceed = this.onFirstPageProceed.bind(this);
    this.onSecondPageProceed = this.onSecondPageProceed.bind(this);
    this.goToFirstPage = this.goToFirstPage.bind(this);
    this.goToSecondPage = this.goToSecondPage.bind(this);
    this.dateChange = this.dateChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.expand = this.expand.bind(this);
    this.collapse = this.collapse.bind(this);
    this.goToNextPage = this.goToNextPage.bind(this);
    this.startABDMFlow = this.startABDMFlow.bind(this);
    this.onSubmitConsent = this.onSubmitConsent.bind(this);
    this.resendOtp = this.resendOtp.bind(this);
    this.onSubmitOtp = this.onSubmitOtp.bind(this);
    this.startCreateFlow = this.startCreateFlow.bind(this);
    this.startLinkingFlow = this.startLinkingFlow.bind(this);
    this.sendOtpLinking = this.sendOtpLinking.bind(this);
    this.goToAddressCreationPage = this.goToAddressCreationPage.bind(this);
    this.enrollAbha = this.enrollAbha.bind(this);
    this.onSubmitOtp2 = this.onSubmitOtp2.bind(this);
    this.resendOtp2 = this.resendOtp2.bind(this);
    this.returnToFirstPage = this.returnToFirstPage.bind(this);
    this.downloadAbha = this.downloadAbha.bind(this);
    this.printAbha = this.printAbha.bind(this);
    this.onSubmitOtpVerify = this.onSubmitOtpVerify.bind(this);
    this.resendOtpVerify = this.resendOtpVerify.bind(this);
    this.onSubmitAccountVerify = this.onSubmitAccountVerify.bind(this);
    this.startScanningFlow = this.startScanningFlow.bind(this);
    this.onScanEnd = this.onScanEnd.bind(this);
    this.changeMethod = this.changeMethod.bind(this);
    this.onChangeSite = this.onChangeSite.bind(this);
    this.nextStepLinking = this.nextStepLinking.bind(this);
    this.fetchAuthModes = this.fetchAuthModes.bind(this);
    this.handleAuthChange = this.handleAuthChange.bind(this);
    this.handleAadhaarFocus = this.handleAadhaarFocus.bind(this);
    this.onCustomFieldBlur = this.onCustomFieldBlur.bind(this);
  }

  fetchAbhaCard = (token, isAbhaAddressAuth = false) => {
    return postAuthenticatedData(
      sessionStorage.getItem("domain") +
        getAbhaCard +
        "?abhaAddressAuthentication=" +
        isAbhaAddressAuth,
      { token: token }
    )
      .then(res => res.json())
      .then(res => {
        if (res.status && res.status.statusCode === "OK" && res.data) {
          this.setState({
            abhaImage: res.data,
            abhaCardAvailable: true,
            abhaCardError: false
          });
        } else {
          let errorMessage = "ABHA Card could not be loaded";
          try {
            if (res.status?.message) {
              const parsedMessage = JSON.parse(res.status.message);
              errorMessage = parsedMessage.message || errorMessage;
            }
          } catch (e) {
            // If parsing fails, use the original message or default
            errorMessage = res.status?.message || errorMessage;
          }

          this.setState({
            abhaCardAvailable: true, // Changed from false to true
            abhaCardError: true,
            abhaImage: "",
            abhaCardErrorMessage: errorMessage // Store the error message
          });
        }
      })
      .catch(error => {
        console.error("ABHA Card fetch error:", error);
        this.setState({
          abhaCardAvailable: true, // Changed from false to true
          abhaCardError: true,
          abhaImage: "",
          abhaCardErrorMessage: "ABHA Card could not be loaded" // Store a default error message
        });
      });
  };

  checkExistingPatient = () => {
    const deviceType = "FOP";
    const siteId = this.state.site;
    const mrn = this.state.mrn;

    return getAuthenticatedData(
      sessionStorage.getItem("domain") +
        "/api/patient/getPatientWithExams/" +
        `${mrn}?deviceType=${deviceType}&siteId=${siteId}`
    );
  };

  acceptNewPatientData = () => {
    // Submit the form with new ABHA data
    this.setState({ showComparison: false }, () => {
      this.submitForm();
    });
  };

  keepOriginalData = () => {
    // Reset to original patient data and submit
    const original = this.state.originalPatientData;
    this.setState(
      {
        mrn: original.mrn,
        firstname: original.firstName,
        lastname: original.lastName,
        gender: original.gender,
        startDate: original.dateOfBirth,
        phoneNumber: original.phoneNumber,
        // Clear ABHA data
        abhaNumber: original.abhaNumber,
        abhaAddress: original.abhaAddress,
        address: original.address,
        districtName: original.district,
        stateName: original.state,
        pinCode: original.pinCode,
        checksum: original.checksum,
        showComparison: false
      },
      () => {
        this.submitForm();
      }
    );
  };

  submitForm = () => {
    let devices = [];
    for (let el of this.state.editDeviceType) {
      devices.push(el);
    }

    let optionalStuff = {};
    if (this.state.examCustomId !== "") {
      optionalStuff.examCustomId = this.state.examCustomId;
    }
    if (this.state.medicalhistory !== "") {
      optionalStuff.medicalHistory = this.state.medicalhistory;
    }
    if (this.state.ocularhistory !== "") {
      optionalStuff.ocularHistory = this.state.ocularhistory;
    }
    if (this.state.currentmedication !== "") {
      optionalStuff.currentMedication = this.state.currentmedication;
    }
    if (this.state.allergies !== "") {
      optionalStuff.allergies = this.state.allergies;
    }

    // Separate custom fields by attribute type
    const examCustomFields = {};
    const patientCustomFields = {};

    if (this.state.customFields && this.state.customFields.length > 0) {
      this.state.customFields.forEach(field => {
        let value = this.state.customFieldValues[field.id];

        // Apply defaults for empty values only on submit
        if (value === "" || value === null || value === undefined) {
          if (field.attributeType === "patient") {
            if (field.id === "diabetesType") {
              value = "Type2";
            } else if (field.id === "diagnosisYear") {
              value = new Date().setFullYear(new Date().getFullYear() - 15);
            }
          } else if (field.attributeType === "exam") {
            if (field.id === "bpSystolic") {
              value = 130;
            } else if (field.id === "HbA1c") {
              value = 8.0;
            }
          }
        }

        if (value !== "" && value !== null && value !== undefined) {
          if (field.attributeType === "exam") {
            examCustomFields[field.id] = value;
          } else if (field.attributeType === "patient") {
            patientCustomFields[field.id] = value;
          }
        }
      });
    }

    // Add exam custom fields to base object as stringified JSON
    if (Object.keys(examCustomFields).length > 0) {
      optionalStuff.customFieldsData = JSON.stringify(examCustomFields);
    }

    if (
      this.state.leftucva !== "" ||
      this.state.leftpg !== "" ||
      this.state.leftsph !== "" ||
      this.state.leftcyl !== "" ||
      this.state.leftaxis !== "" ||
      this.state.leftbcva !== "" ||
      this.state.leftadd !== "" ||
      this.state.leftiop !== ""
    ) {
      optionalStuff.leftEyeVisionAssessment = {};
    }
    if (this.state.leftucva !== "") {
      optionalStuff.leftEyeVisionAssessment.ucva = this.state.leftucva;
    }
    if (this.state.leftpg !== "") {
      optionalStuff.leftEyeVisionAssessment.visionWithPG = this.state.leftpg;
    }
    if (this.state.leftsph !== "") {
      optionalStuff.leftEyeVisionAssessment.sph = this.state.leftsph;
    }
    if (this.state.leftcyl !== "") {
      optionalStuff.leftEyeVisionAssessment.cyl = this.state.leftcyl;
    }
    if (this.state.leftaxis !== "") {
      optionalStuff.leftEyeVisionAssessment.axis = this.state.leftaxis;
    }
    if (this.state.leftbcva !== "") {
      optionalStuff.leftEyeVisionAssessment.bcva = this.state.leftbcva;
    }
    if (this.state.leftadd !== "") {
      optionalStuff.leftEyeVisionAssessment.nearAdd = this.state.leftadd;
    }
    if (this.state.leftiop !== "") {
      optionalStuff.leftEyeVisionAssessment.iop = this.state.leftiop;
    }
    if (
      this.state.rightucva !== "" ||
      this.state.rightpg !== "" ||
      this.state.rightsph !== "" ||
      this.state.rightcyl !== "" ||
      this.state.rightaxis !== "" ||
      this.state.rightbcva !== "" ||
      this.state.rightadd !== "" ||
      this.state.rightiop !== ""
    ) {
      optionalStuff.rightEyeVisionAssessment = {};
    }
    if (this.state.rightucva !== "") {
      optionalStuff.rightEyeVisionAssessment.ucva = this.state.rightucva;
    }
    if (this.state.rightpg !== "") {
      optionalStuff.rightEyeVisionAssessment.visionWithPG = this.state.rightpg;
    }
    if (this.state.rightsph !== "") {
      optionalStuff.rightEyeVisionAssessment.sph = this.state.rightsph;
    }
    if (this.state.rightcyl !== "") {
      optionalStuff.rightEyeVisionAssessment.cyl = this.state.rightcyl;
    }
    if (this.state.rightaxis !== "") {
      optionalStuff.rightEyeVisionAssessment.axis = this.state.rightaxis;
    }
    if (this.state.rightbcva !== "") {
      optionalStuff.rightEyeVisionAssessment.bcva = this.state.rightbcva;
    }
    if (this.state.rightadd !== "") {
      optionalStuff.rightEyeVisionAssessment.nearAdd = this.state.rightadd;
    }
    if (this.state.rightiop !== "") {
      optionalStuff.rightEyeVisionAssessment.iop = this.state.rightiop;
    }
    if (
      this.state.doctorfirstname !== "" ||
      this.state.doctorlastname !== "" ||
      this.state.doctoremail !== ""
    ) {
      optionalStuff.orderingProvider = {
        firstName: this.state.doctorfirstname,
        lastName: this.state.doctorlastname,
        email: this.state.doctoremail
      };
    }

    let data = {
      patient: {
        mrn: this.state.mrn !== "" ? this.state.mrn : undefined,
        firstName:
          this.state.firstname !== "" ? this.state.firstname : undefined,
        lastName: this.state.lastname !== "" ? this.state.lastname : undefined,
        dateOfBirth: this.state.startDate,
        gender: this.state.gender,
        checksum: this.state.checksum,
        siteId: parseInt(this.state.site),
        ...(this.state.abhaNumber && { abhaNumber: this.state.abhaNumber }),
        ...(this.state.abhaAddress && { abhaAddress: this.state.abhaAddress }),
        ...(this.state.address && { address: this.state.address }),
        ...(this.state.stateName && { state: this.state.stateName }),
        ...(this.state.districtName && { district: this.state.districtName }),
        ...(this.state.pinCode && { pinCode: this.state.pinCode }),
        phoneNo: this.state.phoneNumber,
        // Add patient custom fields to patient object as stringified JSON
        ...(Object.keys(patientCustomFields).length > 0 && {
          customFieldsData: JSON.stringify(patientCustomFields)
        })
      },
      examLocalId: "WEB-DASHBOARD" + "::" + new Date().getTime(),
      examDate: new Date().getTime(),
      deviceType: devices,
      ...optionalStuff
    };

    this.setState({ isLoaded: false, disableSecondButton: true });

    postAuthenticatedData(
      sessionStorage.getItem("domain") + createPatientExam,
      data
    )
      .then(result => {
        this.setState({ isLoaded: true });
        if (result.status === 200) {
          toast.success(this.t(T_EXAMS.toast.examAddedSuccessfully));
          this.setState({
            organizationname: "",
            sitedomain: "",
            sitename: "",
            firstname: "",
            lastname: "",
            email: "",
            employeeid: "",
            currentPage: 1
          });
          this.props.closePopup();
          this.props.resetList();
        }
        return result.json();
      })
      .then(resp => {
        if (
          resp.status.statusCode !== "OK" &&
          resp.status.statusCode !== "FORBIDDEN" &&
          resp.status.statusCode !== "NOT_AUTHORIZED"
        ) {
          toast.error(resp.status.message);
        }
      });
  };

  // Add method to handle custom field changes
  onCustomFieldChange(fieldId, value, field) {
    let processedValue = value;

    if (field.type === "number") {
      // For number fields, allow intermediate input while typing
      if (value !== "" && !isNaN(value) && !isNaN(parseFloat(value))) {
        const numValue = parseFloat(value);
        if (field.max !== undefined && numValue > field.max) {
          // Only restrict if the number of digits exceeds what's reasonable
          const maxDigits = field.max.toString().length;
          if (value.length > maxDigits + 1) {
            processedValue = field.max.toString();
          }
        }
      }
      // Allow empty string, decimal points, negative signs for intermediate typing
      if (value === "" || value === "." || value === "-" || value === "-.") {
        processedValue = value;
      }
      if (processedValue !== "" && !isNaN(processedValue)) {
        processedValue = parseFloat(processedValue);
      }
    } else if (field.type === "text") {
      if (field.maxLength && value.length > field.maxLength) {
        processedValue = value.substring(0, field.maxLength);
      }
      // Allow intermediate input for regex validation
    }

    this.setState(
      {
        customFieldValues: {
          ...this.state.customFieldValues,
          [fieldId]: processedValue
        }
      },
      () => {
        // Validate after custom field change
        this.setState({
          disableFirstButton: !this.validateRequiredFields()
        });
      }
    );
  }

  onCustomFieldBlur(fieldId, value, field) {
    if (field.type === "number" && value !== "" && !isNaN(value)) {
      let finalValue = parseFloat(value);

      // Apply min/max validation on blur
      if (field.min !== undefined && finalValue < field.min) {
        finalValue = field.min;
      } else if (field.max !== undefined && finalValue > field.max) {
        finalValue = field.max;
      }

      this.setState({
        customFieldValues: {
          ...this.state.customFieldValues,
          [fieldId]: parseFloat(finalValue)
        }
      });
    }
  }

  // Add method to render custom fields
  renderCustomFields = attributeType => {
    if (!this.state.customFields || this.state.customFields.length === 0) {
      return null;
    }

    // Filter fields by attribute type (patient or exam)
    const fieldsToRender = this.state.customFields.filter(
      field => field.attributeType === attributeType
    );

    if (fieldsToRender.length === 0) {
      return null;
    }

    return fieldsToRender.map(field => {
      const value = this.state.customFieldValues[field.id] || "";

      return (
        <FormGroup key={field.id} controlId={field.id} bsSize="large">
          <div className="row">
            <div className="col-md-3 formfont">
              {field.label}
              {field.required ? "*" : ""}
            </div>
            <div className="col-md-9">
              {this.renderCustomFieldInput(field, value)}
            </div>
          </div>
        </FormGroup>
      );
    });
  };

  // Add method to render individual custom field inputs
  renderCustomFieldInput = (field, value) => {
    switch (field.type) {
      case "text":
        return (
          <FormControl
            type="text"
            name={field.id}
            value={value}
            placeholder={field.placeholder || ""}
            required={field.required}
            maxLength={field.maxLength || undefined}
            minLength={field.minLength || undefined}
            onChange={e =>
              this.onCustomFieldChange(field.id, e.target.value, field)
            }
            inputMode={
              field.keyboard === "alphabet"
                ? "text"
                : field.keyboard === "alphanumeric"
                ? "text"
                : "text"
            }
          />
        );

      case "number":
        return (
          <FormControl
            type="number"
            name={field.id}
            value={value !== "" ? Number(value) : value}
            placeholder={field.placeholder || ""}
            required={field.required}
            min={field.min || undefined}
            max={field.max || undefined}
            onChange={e =>
              this.onCustomFieldChange(field.id, e.target.value, field)
            }
            onBlur={e =>
              this.onCustomFieldBlur(field.id, e.target.value, field)
            }
            inputMode={
              field.keyboard === "numberPad"
                ? "numeric"
                : field.keyboard === "decimalPad"
                ? "decimal"
                : "numeric"
            }
          />
        );

      case "date":
        return (
          <div className="customDatePicker">
            <DatePicker
              selected={value ? new Date(value) : null}
              onChange={date =>
                this.onCustomFieldChange(
                  field.id,
                  date ? date.getTime() : null,
                  field
                )
              }
              dateFormat={
                field.displayFormat === "yyyy"
                  ? "yyyy"
                  : field.displayFormat === "MM/yyyy"
                  ? "MM/yyyy"
                  : field.displayFormat === "yyyy-MM-dd"
                  ? "yyyy-MM-dd"
                  : "dd/MM/yyyy"
              }
              showYearPicker={field.displayFormat === "yyyy"}
              showMonthYearPicker={field.displayFormat === "MM/yyyy"}
              maxDate={field.pastOnly ? new Date() : undefined}
              peekNextMonth
              showMonthDropdown={field.displayFormat !== "yyyy"}
              showYearDropdown
              dropdownMode="select"
              placeholderText={field.placeholder || "Select date"}
              required={field.required}
            />
          </div>
        );

      case "picker":
        return (
          <select
            name={field.id}
            value={value}
            required={field.required}
            onChange={e =>
              this.onCustomFieldChange(field.id, e.target.value, field)
            }
          >
            <option value="">{field.placeholder || "Select an option"}</option>
            {field.options &&
              field.options.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.display}
                </option>
              ))}
          </select>
        );

      default:
        return (
          <FormControl
            type="text"
            name={field.id}
            value={value}
            placeholder={field.placeholder || ""}
            required={field.required}
            onChange={e =>
              this.onCustomFieldChange(field.id, e.target.value, field)
            }
          />
        );
    }
  };

  handleAadhaarFocus() {
    this.setState({ maskedAadhaar: "" });
  }

  handleAuthChange(event) {
    const selectedValue = event.target.value;
    if (selectedValue === "abha") {
      this.setState({ method: "abhaAddressViaAbha" });
    } else if (selectedValue === "aadhaar") {
      this.setState({ method: "abhaAddressViaAadhaar" });
    }
  }

  fetchAuthModes() {
    this.setState({ isLoaded: false, disableVerifyButton: true });
    postAuthenticatedABDMData("POST", abdmM1PHRURL + "/login/abha/search", {
      abhaAddress: this.state.abhaAddress
    }).then(res => {
      if (res.status.statusCode === "OK") {
        this.setState({
          authModes: res.data.authMethods,
          isLoaded: true,
          disableVerifyButton: false,
          authModesFetched: true
        });
      } else {
        toast.error(
          "ABHA Address does not exist. Please check the address and try again."
        );
        this.setState({ isLoaded: true, disableVerifyButton: false });
      }
    });
  }

  nextStepLinking() {
    if (this.state.method === "abhaAddress") {
      this.fetchAuthModes();
    } else {
      this.sendOtpLinking();
    }
  }

  startOtpTimer() {
    // Clear any existing timer
    if (this.timerID) {
      clearInterval(this.timerID);
    }

    // Reset the timer state
    this.setState({
      timeLeft: 60,
      isFinished: false
    });

    // Start a new timer
    this.timerID = setInterval(() => {
      this.setState(prevState => {
        if (prevState.timeLeft <= 1) {
          clearInterval(this.timerID);
          return { timeLeft: 0, isFinished: true };
        }
        return { timeLeft: prevState.timeLeft - 1 };
      });
    }, 1000);
  }

  onChangeSite(e) {
    this.setState({ [e.target.name]: [e.target.value] });
    getAuthenticatedData(
      sessionStorage.getItem("domain") +
        "/api/abdm/fetchCheckInQueue?siteId=" +
        e.target.value
    ).then(res => {
      this.setState({ scanAccounts: res.data });
    });
  }

  changeMethod(e) {
    this.setState({ method: e.target.value });
  }

  validateAadhaar(aadhaarNumber) {
    const d = [
      [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      [1, 2, 3, 4, 0, 6, 7, 8, 9, 5],
      [2, 3, 4, 0, 1, 7, 8, 9, 5, 6],
      [3, 4, 0, 1, 2, 8, 9, 5, 6, 7],
      [4, 0, 1, 2, 3, 9, 5, 6, 7, 8],
      [5, 9, 8, 7, 6, 0, 4, 3, 2, 1],
      [6, 5, 9, 8, 7, 1, 0, 4, 3, 2],
      [7, 6, 5, 9, 8, 2, 1, 0, 4, 3],
      [8, 7, 6, 5, 9, 3, 2, 1, 0, 4],
      [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]
    ];
    const p = [
      [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      [1, 5, 7, 6, 2, 8, 3, 0, 9, 4],
      [5, 8, 0, 3, 7, 9, 6, 1, 4, 2],
      [8, 9, 1, 6, 0, 4, 3, 5, 2, 7],
      [9, 4, 5, 3, 1, 2, 6, 8, 7, 0],
      [4, 2, 8, 6, 5, 7, 3, 9, 0, 1],
      [2, 7, 9, 3, 8, 0, 6, 4, 1, 5],
      [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]
    ];

    let c = 0;
    const reversedAadhaar = aadhaarNumber.split("").reverse();

    for (let i = 0; i < reversedAadhaar.length; i++) {
      c = d[c][p[(i + 1) % 8][parseInt(reversedAadhaar[i])]];
    }

    return c === 0;
  }

  onScanEnd(index) {
    this.setState(
      {
        currentPage: 1,
        collapsed: false,
        disableFirstButton: false,
        isLoaded: true,
        mrn: this.state.scanAccounts[index].abhaNumber
          ? "ABHA-" + this.state.scanAccounts[index].abhaNumber
          : "",
        abhaNumber: this.state.scanAccounts[index].abhaNumber,
        abhaAddress: this.state.scanAccounts[index].abhaAddress,
        checksum: this.state.scanAccounts[index].checksum,
        phoneNumber: this.state.scanAccounts[index].phoneNumber,
        firstname: this.state.scanAccounts[index].name
          .split(" ")
          .slice(0, -1)
          .join(" "),
        lastname: this.state.scanAccounts[index].name.split(" ").pop(),
        gender:
          this.state.scanAccounts[index].gender === "M" ? "MALE" : "FEMALE",
        address: this.state.scanAccounts[index].addressLine,
        districtName: this.state.scanAccounts[index].addressDistrict,
        stateName: this.state.scanAccounts[index].addressState,
        pinCode: this.state.scanAccounts[index].addressPin,
        startDate: new Date(
          this.state.scanAccounts[index].yearOfBirth +
            "-" +
            this.state.scanAccounts[index].monthOfBirth +
            "-" +
            this.state.scanAccounts[index].dayOfBirth
        ).getTime(),
        age: differenceInYears(
          new Date().getTime(),
          new Date(
            this.state.scanAccounts[index].yearOfBirth +
              "-" +
              this.state.scanAccounts[index].monthOfBirth +
              "-" +
              this.state.scanAccounts[index].dayOfBirth
          ).getTime()
        )
      },
      () => {
        // Add this validation callback
        this.setState({
          disableFirstButton: !this.validateRequiredFields()
        });
      }
    );
  }

  startScanningFlow() {
    getAuthenticatedData(
      sessionStorage.getItem("domain") +
        "/api/abdm/fetchCheckInQueue?siteId=" +
        this.state.site
    ).then(res => {
      this.setState({ scanAccounts: res.data, currentPage: 14 });
    });
  }

  async onSubmitAccountVerify() {
    if (this.state.method === "phoneNumber") {
      this.setState({
        isLoaded: false,
        disableSubmitAccountVerifyButton: true
      });
      const plainText = this.state.accountsVerify[
        this.state.selectedAccountVerify
      ].index.toString();

      try {
        const encryptedText = await this.encryptText(
          plainText.replace(/-/g, ""),
          this.state.publicKeyPem
        );
        postAuthenticatedABDMData(
          "POST",
          abdmM1URL + "/v3/profile/login/request/otp",
          {
            scope: ["abha-login", "search-abha", "mobile-verify"],
            loginHint: "index",
            loginId: encryptedText,
            otpSystem: "abdm",
            txnId: this.state.txnId
          }
        ).then(res => {
          if (res.status.statusCode === "OK") {
            toast.success(res.data.message);
            this.setState({
              currentPage: 12,
              txnId2: res.data.txnId,
              disableFirstButton: false,
              isLoaded: true
            });
            this.startOtpTimer();
          } else {
            this.setState({ isLoaded: true, disableButton: false });
            toast.error(res.status.message);
          }
        });
      } catch (error) {
        this.setState({ isLoaded: true, disableButton: false });
        toast.error("Error in encrypting your data.");
      }
    } else {
      this.setState(
        {
          currentPage: 1,
          isLoaded: true,
          disableFirstButton: false,
          collapsed: false,
          mrn: this.state.accountsVerify[this.state.selectedAccountVerify]
            .ABHANumber
            ? "ABHA-" +
              this.state.accountsVerify[this.state.selectedAccountVerify]
                .ABHANumber
            : this.state.accountsVerify[this.state.selectedAccountVerify]
                .abhaNumber
            ? "ABHA-" +
              this.state.accountsVerify[this.state.selectedAccountVerify]
                .abhaNumber
            : "",
          abhaNumber:
            this.state.accountsVerify[this.state.selectedAccountVerify]
              .ABHANumber ||
            this.state.accountsVerify[this.state.selectedAccountVerify]
              .abhaNumber,
          abhaAddress:
            this.state.accountsVerify[this.state.selectedAccountVerify]
              .preferredAbhaAddress ||
            this.state.accountsVerify[this.state.selectedAccountVerify]
              .abhaAddress,
          firstname:
            this.state.accountsVerify[
              this.state.selectedAccountVerify
            ]?.fullName
              ?.split(" ")
              ?.slice(0, -1)
              ?.join(" ") ||
            this.state.accountsVerify[this.state.selectedAccountVerify]
              .firstName +
              (this.state.accountsVerify[this.state.selectedAccountVerify]
                .middleName !== ""
                ? " " +
                  this.state.accountsVerify[this.state.selectedAccountVerify]
                    .middleName
                : ""),
          lastname: this.state.accountsVerify[this.state.selectedAccountVerify]
            .lastName,
          checksum: this.state.accountsVerify[this.state.selectedAccountVerify]
            .checksum,
          address: this.state.accountsVerify[this.state.selectedAccountVerify]
            .address,
          pinCode:
            this.state.accountsVerify[this.state.selectedAccountVerify]
              .pincode ||
            this.state.accountsVerify[this.state.selectedAccountVerify].pinCode,
          districtName: this.state.accountsVerify[
            this.state.selectedAccountVerify
          ].districtName,
          stateName: this.state.accountsVerify[this.state.selectedAccountVerify]
            .stateName,
          phoneNumber: this.state.accountsVerify[
            this.state.selectedAccountVerify
          ].mobile
            ? this.state.accountsVerify[this.state.selectedAccountVerify].mobile
            : this.state.phoneNumber,
          gender:
            this.state.accountsVerify[this.state.selectedAccountVerify]
              .gender === "M"
              ? "MALE"
              : "FEMALE",
          startDate: new Date(
            this.state.accountsVerify[this.state.selectedAccountVerify]
              .yearOfBirth +
              "-" +
              this.state.accountsVerify[this.state.selectedAccountVerify]
                .monthOfBirth +
              "-" +
              this.state.accountsVerify[this.state.selectedAccountVerify]
                .dayOfBirth
          ).getTime(),
          age: differenceInYears(
            new Date().getTime(),
            new Date(
              this.state.accountsVerify[this.state.selectedAccountVerify]
                .yearOfBirth +
                "-" +
                this.state.accountsVerify[this.state.selectedAccountVerify]
                  .monthOfBirth +
                "-" +
                this.state.accountsVerify[this.state.selectedAccountVerify]
                  .dayOfBirth
            ).getTime()
          )
        },
        () => {
          // Add this validation callback
          this.setState({
            disableFirstButton: !this.validateRequiredFields()
          });
        }
      );
    }
  }

  async resendOtpVerify() {
    if (this.state.resendCountVerify >= 2) {
      toast.error("Max limit exceeded");
      return;
    }

    this.setState({
      isLoaded: false,
      disableOtpButton: true,
      resendCountVerify: this.state.resendCountVerify + 1,
      otp: ""
    });
    let plainText, loginHint;
    if (this.state.method === "phoneNumber") {
      plainText = this.state.phoneNumber;
      loginHint = "mobile";
    } else if (
      this.state.method === "abhaNumberViaAbha" ||
      this.state.method === "abhaNumberViaAadhaar"
    ) {
      plainText = this.state.abhaNumber;
      loginHint = "abha-number";
    } else if (this.state.method === "aadhaarNumber") {
      plainText = this.state.aadhaarNumber;
      loginHint = "aadhaar";
    } else {
      plainText = this.state.abhaAddress;
      loginHint = "abha-address";
    }

    if (this.state.method === "phoneNumber") {
      this.setState({
        isLoaded: false,
        disableSubmitAccountVerifyButton: true
      });
      const plainText = this.state.accountsVerify[
        this.state.selectedAccountVerify
      ].index.toString();

      try {
        const encryptedText = await this.encryptText(
          plainText.replace(/-/g, ""),
          this.state.publicKeyPem
        );
        postAuthenticatedABDMData(
          "POST",
          abdmM1URL + "/v3/profile/login/request/otp",
          {
            scope: ["abha-login", "search-abha", "mobile-verify"],
            loginHint: "index",
            loginId: encryptedText,
            otpSystem: "abdm",
            txnId: this.state.txnId
          }
        ).then(res => {
          if (res.status.statusCode === "OK") {
            toast.success(res.data.message);
            this.setState({
              currentPage: 12,
              txnId2: res.data.txnId,
              disableFirstButton: false,
              isLoaded: true
            });
            this.startOtpTimer();
          } else {
            this.setState({ isLoaded: true, disableButton: false });
            toast.error(res.status.message);
          }
        });
      } catch (error) {
        this.setState({ isLoaded: true, disableButton: false });
        toast.error("Error in encrypting your data.");
      }
    } else {
      try {
        const encryptedText = await this.encryptText(
          plainText,
          this.state.publicKeyPem
        );
        postAuthenticatedABDMData(
          "POST",
          this.state.method === "abhaAddressViaAadhaar" ||
            this.state.method === "abhaAddressViaAbha"
            ? abdmM1PHRURL + "/login/abha/request/otp"
            : abdmM1URL + "/v3/profile/login/request/otp",
          {
            scope: [
              this.state.method === "abhaAddressViaAbha" ||
              this.state.method === "abhaAddressViaAadhaar"
                ? "abha-address-login"
                : "abha-login",
              this.state.method === "aadhaarNumber" ||
              this.state.method === "abhaNumberViaAadhaar" ||
              this.state.method === "abhaAddressViaAadhaar"
                ? "aadhaar-verify"
                : "mobile-verify"
            ],
            loginHint,
            loginId: encryptedText,
            otpSystem:
              this.state.method === "aadhaarNumber" ||
              this.state.method === "abhaNumberViaAadhaar" ||
              this.state.method === "abhaAddressViaAadhaar"
                ? "aadhaar"
                : "abdm"
          }
        ).then(res => {
          if (res.status.statusCode === "OK") {
            this.setState({
              isLoaded: true,
              txnId: res.data.txnId
            });
            toast.success(res.data.message);
            this.startOtpTimer();
          } else {
            this.setState({ isLoaded: true, disableButton: false });
            toast.error(res.status.message);
          }
        });
      } catch (error) {
        this.setState({ isLoaded: true, disableButton: false });
        toast.error("Error in encrypting your data.");
      }
    }
  }

  async onSubmitOtpVerify() {
    if (this.state.method === "phoneNumber") {
      this.setState({ isLoaded: false, disableOtpButton: true });
      const plainText = this.state.otp;
      const encryptedText = await this.encryptText(
        plainText,
        this.state.publicKeyPem
      );
      postAuthenticatedABDMData(
        "POST",
        abdmM1URL + "/v3/profile/login/verify",
        {
          scope: ["abha-login", "mobile-verify"],
          authData: {
            authMethods: ["otp"],
            otp: {
              txnId: this.state.txnId2,
              otpValue: encryptedText
            }
          }
        }
      ).then(res => {
        postAuthenticatedABDMData(
          "GET",
          abdmM1URL + "/v3/profile/account",
          {},
          { "X-token": "Bearer " + res.data.token }
        )
          .then(res2 => {
            if (
              res.status.statusCode === "OK" &&
              res.data.authResult !== "Failed" &&
              res.data.authResult !== "failed"
            ) {
              toast.success(res.data.message);
              this.setState(
                {
                  firstname:
                    res2.data.firstName +
                    (res2.data.middleName !== ""
                      ? " " + res2.data.middleName
                      : ""),
                  lastname: res2.data.lastName,
                  dob:
                    res2.data.dayOfBirth +
                    "-" +
                    res2.data.monthOfBirth +
                    "-" +
                    res2.data.yearOfBirth,
                  startDate: new Date(
                    res2.data.yearOfBirth +
                      "-" +
                      res2.data.monthOfBirth +
                      "-" +
                      res2.data.dayOfBirth
                  ).getTime(),
                  age: differenceInYears(
                    new Date().getTime(),
                    new Date(
                      res2.data.yearOfBirth +
                        "-" +
                        res2.data.monthOfBirth +
                        "-" +
                        res2.data.dayOfBirth
                    ).getTime()
                  ),
                  gender: res2.data.gender === "M" ? "MALE" : "FEMALE",
                  mrn: res2.data.ABHANumber
                    ? "ABHA-" + res2.data.ABHANumber
                    : "",
                  abhaNumber: res2.data.ABHANumber,
                  abhaAddress: res2.data.preferredAbhaAddress,
                  checksum: res2.data.checksum,
                  address: res2.data.address,
                  districtName: res2.data.districtName,
                  stateName: res2.data.stateName,
                  pinCode: res2.data.pincode,
                  currentPage: 1,
                  isLoaded: true,
                  disableFirstButton: false,
                  collapsed: false
                },
                () => {
                  // Add this validation callback
                  this.setState({
                    disableFirstButton: !this.validateRequiredFields()
                  });
                }
              );
            } else {
              this.setState({ isLoaded: true, disableOtpButton: false });
              toast.error(res.data.message);
            }
          })
          .then(() => {
            this.fetchAbhaCard(
              res.data.token || res.data.tokens.token,
              this.state.method === "abhaAddressViaAbha" ||
                this.state.method === "abhaAddressViaAadhaar"
            );
          });
      });
    } else {
      this.setState({ isLoaded: false, disableOtpButton: true });
      const plainText = this.state.otp;
      const encryptedText = await this.encryptText(
        plainText,
        this.state.publicKeyPem
      );
      postAuthenticatedABDMData(
        "POST",
        this.state.method === "abhaAddressViaAadhaar" ||
          this.state.method === "abhaAddressViaAbha"
          ? abdmM1PHRURL + "/login/abha/verify"
          : abdmM1URL + "/v3/profile/login/verify",
        {
          scope: [
            this.state.method === "abhaAddressViaAbha" ||
            this.state.method === "abhaAddressViaAadhaar"
              ? "abha-address-login"
              : "abha-login",
            this.state.method === "aadhaarNumber" ||
            this.state.method === "abhaAddressViaAadhaar" ||
            this.state.method === "abhaNumberViaAadhaar"
              ? "aadhaar-verify"
              : "mobile-verify"
          ],
          authData: {
            authMethods: ["otp"],
            otp: {
              txnId: this.state.txnId,
              otpValue: encryptedText
            }
          }
        }
      )
        .then(async res => {
          if (
            res.status.statusCode === "OK" &&
            res.data.authResult !== "Failed" &&
            res.data.authResult !== "failed"
          ) {
            toast.success(res.data.message);
            this.setState({
              txnId: res.data.txnId,
              isLoaded: true,
              ...(this.state.method === "phoneNumber" && {
                accountsVerify: res.data.accounts
              }),
              verifyToken: res.data.token || res.data.tokens.token
            });
            if (this.state.method === "phoneNumber") {
              this.goToNextPage();
            }
            clearInterval(this.timerID);
            this.fetchAbhaCard(
              res.data.token || res.data.tokens.token,
              this.state.method === "abhaAddressViaAbha" ||
                this.state.method === "abhaAddressViaAadhaar"
            );
          } else {
            this.setState({ isLoaded: true, disableOtpButton: false });
            if (res.status.message.includes("ABDM-1100")) {
              toast.error("You have exceeded the maximum number of attempts");
            } else if (res.status.message.includes("ABDM-1114")) {
              toast.error("No ABHA user registered with this Aadhaar number.");
              this.setState({ currentPage: 5 });
            } else {
              toast.error("Wrong OTP entered.");
            }
          }
          return res;
        })
        .then(res => {
          if (
            this.state.method !== "phoneNumber" &&
            res.data.authResult &&
            res.data.authResult !== "failed"
          ) {
            postAuthenticatedABDMData(
              "GET",
              this.state.method.includes("Address")
                ? abdmM1PHRURL + "/login/profile/abha-profile"
                : abdmM1URL + "/v3/profile/account",
              {},
              { "X-token": "Bearer " + this.state.verifyToken }
            ).then(res => {
              this.setState({ accountsVerify: [res.data] });
              this.goToNextPage();
            });
          }
        });
    }
  }

  printAbha() {
    if (!this.state.abhaCardAvailable || !this.state.abhaImage) {
      if (this.state.abhaCardErrorMessage) {
        toast.error(this.state.abhaCardErrorMessage);
      } else {
        toast.error("ABHA Card is not available for download");
      }
      return;
    }
    const iframe = document.createElement("iframe");
    const src = this.state.abhaImage;

    // Hide the iframe
    iframe.style.visibility = "hidden";
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";

    // Set up load event for the iframe
    iframe.onload = function() {
      const doc = iframe.contentDocument || iframe.contentWindow.document;
      const img = doc.createElement("img");

      img.onload = function() {
        doc.body.appendChild(img);

        // Wait a bit for the image to be fully loaded and rendered
        setTimeout(function() {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();

          // Remove the iframe after printing
          setTimeout(function() {
            document.body.removeChild(iframe);
          }, 1000);
        }, 250);
      };

      img.onerror = function() {
        document.body.removeChild(iframe);
      };

      img.src = src;
    };

    // Add the iframe to the page to start loading
    document.body.appendChild(iframe);
  }

  downloadAbha() {
    if (!this.state.abhaCardAvailable || !this.state.abhaImage) {
      if (this.state.abhaCardErrorMessage) {
        toast.error(this.state.abhaCardErrorMessage);
      } else {
        toast.error("ABHA Card is not available for download");
      }
      return;
    }
    fetch(this.state.abhaImage)
      .then(response => {
        // Try to get the filename from the Content-Disposition header
        const contentDisposition = response.headers.get("Content-Disposition");
        let filename = "download";
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i);
          if (filenameMatch) {
            filename = filenameMatch[1];
          }
        }
        // If no filename found, use a generic name with timestamp
        if (filename === "download") {
          const fileExtension =
            response.headers.get("Content-Type")?.split("/")[1] || "png";
          filename = `image_${Date.now()}.${fileExtension}`;
        }
        return Promise.all([response.blob(), filename]);
      })
      .then(([blob, filename]) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      })
      .catch(() => toast.error("Error downloading image"));
  }

  returnToFirstPage() {
    this.setState(
      {
        currentPage: 1,
        collapsed: false,
        disableFirstButton: false,
        isLoaded: true
      },
      () => {
        // Validate after custom field change
        this.setState({
          disableFirstButton: !this.validateRequiredFields()
        });
      }
    );
  }

  async resendOtp2() {
    if (this.state.resendCount2 >= 2) {
      toast.error("Max limit exceeded");
      return;
    }

    this.setState({
      isLoaded: false,
      disableOtpButton: true,
      resendCount2: this.state.resendCount2 + 1,
      otp: ""
    });
    const encryptedText = await this.encryptText(
      this.state.phoneNumber,
      this.state.publicKeyPem
    );
    postAuthenticatedABDMData(
      "POST",
      abdmM1URL + "/v3/enrollment/request/otp",
      {
        txnId: this.state.txnId,
        scope: ["abha-enrol", "mobile-verify"],
        loginHint: "mobile",
        loginId: encryptedText,
        otpSystem: "abdm"
      },
      {},
      { patientConsentGranted: true }
    ).then(res2 => {
      if (res2.status.statusCode === "OK") {
        toast.success(res2.data.message);
        this.startOtpTimer();
      } else {
        this.setState({
          isFinished: true,
          disableOtpButton: false,
          timeLeft: 60,
          isLoaded: true
        });
      }
    });
  }

  async onSubmitOtp2() {
    this.setState({ isLoaded: false, disableOtpButton: true });
    const plainText = this.state.otp;
    const encryptedText = await this.encryptText(
      plainText,
      this.state.publicKeyPem
    );
    postAuthenticatedABDMData(
      "POST",
      abdmM1URL + "/v3/enrollment/auth/byAbdm",
      {
        scope: ["abha-enrol", "mobile-verify"],
        authData: {
          authMethods: ["otp"],
          otp: {
            timeStamp: new Date().toISOString(),
            txnId: this.state.txnId,
            otpValue: encryptedText
          }
        }
      }
    ).then(async res => {
      if (
        res.status.statusCode === "OK" &&
        res.data.authResult !== "Failed" &&
        res.data.authResult !== "failed"
      ) {
        toast.success(res.data.message);
        this.setState({
          txnId: res.data.txnId,
          isLoaded: true
        });
        this.goToNextPage();
        clearInterval(this.timerID);
      } else {
        this.setState({ isLoaded: true, disableOtpButton: false });
        if (res.status.message.includes("ABDM-1100")) {
          toast.error("You have exceeded the maximum number of attempts");
        } else {
          toast.error("Wrong OTP entered.");
        }
      }
    });
  }

  enrollAbha() {
    this.setState({ isLoaded: false, disableAbhaAddressButton: true });
    postAuthenticatedABDMData(
      "POST",
      abdmM1URL + "/v3/enrollment/enrol/abha-address",
      {
        txnId: this.state.txnId,
        abhaAddress: this.state.abhaAddress.split("@abdm")[0],
        preferred: 1
      }
    ).then(res => {
      if (res.status.statusCode === "OK") {
        this.fetchAbhaCard(
          this.state.token,
          this.state.method === "abhaAddressViaAbha" ||
            this.state.method === "abhaAddressViaAadhaar"
        ).then(() => {
          this.goToNextPage();
        });
      } else {
        if (res.status.message.includes("ABDM-1101")) {
          toast.error(
            "This ABHA Address already exists. Please create with unique ABHA Address."
          );
        } else {
          toast.error("This ABHA Address is invalid. Please choose another.");
        }
        this.setState({ disableAbhaAddressButton: false, isLoaded: true });
      }
    });
  }

  goToAddressCreationPage() {
    this.setState({ isLoaded: false, disableProfileButton: true });
    postAuthenticatedABDMData(
      "GET",
      abdmM1URL + "/v3/enrollment/enrol/suggestion",
      {},
      { Transaction_Id: this.state.txnId }
    ).then(res => {
      if (res.status.statusCode === "OK") {
        this.setState({
          isLoaded: true,
          abhaAddressList: res.data.abhaAddressList
        });
        toast.success(res.data.message);
        this.goToNextPage();
      } else {
        toast.error(res.status.message);
        this.setState({
          disableProfileButton: false,
          isLoaded: true,
          abhaAddressList: []
        });
        this.goToNextPage();
      }
    });
  }

  async sendOtpLinking() {
    this.setState({ isLoaded: false, disableVerifyButton: true });
    let plainText, loginHint;
    if (this.state.method === "phoneNumber") {
      plainText = this.state.phoneNumber;
      loginHint = "mobile";
    } else if (
      this.state.method === "abhaNumberViaAbha" ||
      this.state.method === "abhaNumberViaAadhaar"
    ) {
      plainText = this.state.abhaNumber;
      loginHint = "abha-number";
    } else if (this.state.method === "aadhaarNumber") {
      plainText = this.state.aadhaarNumber;
      loginHint = "aadhaar";
    } else {
      plainText = this.state.abhaAddress;
      loginHint = "abha-address";
    }

    try {
      const encryptedText = await this.encryptText(
        plainText,
        this.state.publicKeyPem
      );
      if (this.state.method !== "phoneNumber") {
        postAuthenticatedABDMData(
          "POST",
          this.state.method === "abhaAddressViaAadhaar" ||
            this.state.method === "abhaAddressViaAbha"
            ? abdmM1PHRURL + "/login/abha/request/otp"
            : abdmM1URL + "/v3/profile/login/request/otp",
          {
            scope: [
              this.state.method === "abhaAddressViaAadhaar" ||
              this.state.method === "abhaAddressViaAbha"
                ? "abha-address-login"
                : "abha-login",
              this.state.method === "aadhaarNumber" ||
              this.state.method === "abhaNumberViaAadhaar" ||
              this.state.method === "abhaAddressViaAadhaar"
                ? "aadhaar-verify"
                : "mobile-verify"
            ],
            loginHint,
            loginId: encryptedText,
            otpSystem:
              this.state.method === "aadhaarNumber" ||
              this.state.method === "abhaNumberViaAadhaar" ||
              this.state.method === "abhaAddressViaAadhaar"
                ? "aadhaar"
                : "abdm"
          }
        ).then(res => {
          if (res.status.statusCode === "OK") {
            this.setState({
              isLoaded: true,
              txnId: res.data.txnId
            });
            toast.success(res.data.message);
            this.goToNextPage();
            this.startOtpTimer();
          } else {
            this.setState({ isLoaded: true, disableVerifyButton: false });
            if (
              this.state.method === "abhaNumberViaAadhaar" ||
              this.state.method === "abhaNumberViaAbha"
            ) {
              toast.error("The ABHA Number entered is invalid.");
            } else if (
              this.state.method === "abhaAddressViaAadhaar" ||
              this.state.method === "abhaAddressViaAbha"
            ) {
              toast.error("The ABHA Address entered is invalid.");
            } else if (this.state.method === "aadhaarNumber") {
              this.setState({ couldBeUnlinked: true });
              toast.error(
                JSON.parse(res.status.message)?.message
                  ? JSON.parse(res.status.message)?.message
                  : "Invalid Aadhaar Number"
              );
            }
          }
        });
      } else {
        const regex = /^[6-9][0-9]{9}$/;
        if (!regex.test(plainText)) {
          toast.error("Invalid Phone Number");
          this.setState({ isLoaded: true, disableVerifyButton: false });
          return;
        }
        postAuthenticatedABDMData(
          "POST",
          abdmM1URL + "/v3/profile/account/abha/search",
          { scope: ["search-abha"], mobile: encryptedText }
        ).then(res => {
          if (res.status.statusCode === "OK") {
            this.setState({
              isLoaded: true,
              txnId: JSON.parse(res.data)[0].txnId,
              accountsVerify: JSON.parse(res.data)[0].ABHA,
              currentPage: 15
            });
          } else {
            toast.error(
              "The mobile number you have entered does not match with any of the records. Please enter a different number."
            );
            this.setState({
              isLoaded: true,
              disableVerifyButton: false,
              couldBeUnlinked: true
            });
          }
        });
      }
    } catch (error) {
      this.setState({ isLoaded: true, disableVerifyButton: false });
      toast.error("Error in encrypting your data.");
    }
  }

  startCreateFlow() {
    this.goToNextPage();
  }

  startLinkingFlow() {
    this.setState({ currentPage: 11, linkingFlow: true });
  }

  async onSubmitOtp() {
    this.setState({ isLoaded: false, disableOtpButton: true });
    const plainText = this.state.otp;

    try {
      const encryptedText = await this.encryptText(
        plainText,
        this.state.publicKeyPem
      );
      postAuthenticatedABDMData(
        "POST",
        abdmM1URL + "/v3/enrollment/enrol/byAadhaar",
        {
          authData: {
            authMethods: ["otp"],
            otp: {
              txnId: this.state.txnId,
              otpValue: encryptedText,
              mobile: this.state.phoneNumber
            }
          },
          consent: {
            code: "abha-enrollment",
            version: "1.4"
          }
        }
      ).then(async res => {
        if (res.status.statusCode === "OK") {
          toast.success(res.data.message);
          this.setState({
            isLoaded: true,
            txnId: res.data.txnId,
            firstname:
              res.data.ABHAProfile.firstName +
              (res.data.ABHAProfile.middleName !== ""
                ? " " + res.data.ABHAProfile.middleName
                : ""),
            lastname: res.data.ABHAProfile.lastName,
            dob: res.data.ABHAProfile.dob,
            checksum: res.data.checksum,
            startDate: new Date(
              res.data.ABHAProfile.dob
                .split("-")
                .reverse()
                .join("-")
            ).getTime(),
            age: differenceInYears(
              new Date().getTime(),
              new Date(
                res.data.ABHAProfile.dob
                  .split("-")
                  .reverse()
                  .join("-")
              ).getTime()
            ),
            gender: res.data.ABHAProfile.gender === "M" ? "MALE" : "FEMALE",
            address: res.data.ABHAProfile.address,
            districtName: res.data.ABHAProfile.districtName,
            pinCode: res.data.ABHAProfile.pinCode,
            stateName: res.data.ABHAProfile.stateName,
            token: res.data.tokens.token,
            mrn: res.data.ABHAProfile.ABHANumber
              ? "ABHA-" + res.data.ABHAProfile.ABHANumber
              : "",
            abhaNumber: res.data.ABHAProfile.ABHANumber,
            predefinedAbhaAddress:
              res.data.ABHAProfile.phrAddress &&
              res.data.ABHAProfile.phrAddress.length > 0
                ? res.data.ABHAProfile.phrAddress[0]
                : undefined
          });
          if (res.data.ABHAProfile.mobile !== this.state.phoneNumber) {
            const encryptedText = await this.encryptText(
              this.state.phoneNumber,
              this.state.publicKeyPem
            );
            postAuthenticatedABDMData(
              "POST",
              abdmM1URL + "/v3/enrollment/request/otp",
              {
                txnId: res.data.txnId,
                scope: ["abha-enrol", "mobile-verify"],
                loginHint: "mobile",
                loginId: encryptedText,
                otpSystem: "abdm"
              },
              {},
              { patientConsentGranted: true }
            ).then(res2 => {
              if (res2.status.statusCode === "OK") {
                toast.success(res2.data.message);
                this.goToNextPage();
                this.setState({ otp: "" });
                this.startOtpTimer();
              } else {
                this.setState({ isLoaded: true, disableOtpButton: false });
                if (res2.status.message.includes("ABDM-1100")) {
                  toast.error(
                    "You have exceeded the maximum number of attempts"
                  );
                } else {
                  toast.error("Wrong OTP entered.");
                }
              }
            });
          } else {
            this.setState({ currentPage: 8 });
          }
          clearInterval(this.timerID);
        } else {
          this.setState({ isLoaded: true, disableOtpButton: false, otp: "" });
          toast.error(
            "Invalid Aadhaar OTP. Entered OTP is either expired or incorrect."
          );
        }
      });
    } catch (error) {
      this.setState({ isLoaded: true, disableButton: false });
      toast.error("Error in encrypting your data.");
    }
  }

  async resendOtp() {
    if (this.state.resendCount >= 2) {
      toast.error("Max limit exceeded");
      return;
    }
    this.startOtpTimer();
    this.setState({
      isLoaded: false,
      disableOtpButton: true,
      resendCount: this.state.resendCount + 1,
      otp: ""
    });
    const plainText = this.state.aadhaarNumber;

    try {
      const encryptedText = await this.encryptText(
        plainText,
        this.state.publicKeyPem
      );
      postAuthenticatedABDMData(
        "POST",
        abdmM1URL + "/v3/enrollment/request/otp",
        {
          scope: ["abha-enrol"],
          loginHint: "aadhaar",
          loginId: encryptedText,
          otpSystem: "aadhaar"
        },
        {},
        { patientConsentGranted: true }
      ).then(res => {
        if (res.status.statusCode === "OK") {
          toast.success(res.data.message);
          this.setState({
            isLoaded: true,
            txnId: res.data.txnId,
            disableOtpButton: false
          });
        } else {
          toast.error(res.status.message);
          this.setState({ isLoaded: true, disableOtpButton: true });
        }
      });
    } catch (error) {
      this.setState({ isLoaded: true, disableOtpButton: false });
      toast.error("Error in encrypting your data.");
    }
  }

  async importPublicKey(pemKey) {
    // Remove the PEM header and footer
    const pemHeader = "-----BEGIN PUBLIC KEY-----";
    const pemFooter = "-----END PUBLIC KEY-----";
    const pemContents = pemKey
      .replace(pemHeader, "")
      .replace(pemFooter, "")
      .replace(/\n/g, "");

    // Decode base64 and convert to ArrayBuffer
    const binaryDerString = window.atob(pemContents);
    const binaryDer = new Uint8Array(binaryDerString.length);
    for (let i = 0; i < binaryDerString.length; i++) {
      binaryDer[i] = binaryDerString.charCodeAt(i);
    }

    // Import the public key
    return await window.crypto.subtle.importKey(
      "spki",
      binaryDer.buffer,
      {
        name: "RSA-OAEP",
        hash: { name: "SHA-1" }
      },
      true,
      ["encrypt"]
    );
  }

  async encryptText(plainText, pemPublicKey) {
    try {
      // Import the public key
      const publicKey = await this.importPublicKey(pemPublicKey);

      // Encode the plain text as a Uint8Array
      const encoder = new TextEncoder();
      const encodedText = encoder.encode(plainText);

      // Encrypt the data using RSA-OAEP
      const encryptedData = await window.crypto.subtle.encrypt(
        {
          name: "RSA-OAEP"
        },
        publicKey,
        encodedText
      );

      // Convert the ArrayBuffer to base64 for easy transmission/storage
      const encryptedBase64 = window.btoa(
        String.fromCharCode(...new Uint8Array(encryptedData))
      );

      return encryptedBase64;
    } catch (error) {
      return null;
    }
  }

  async onSubmitConsent() {
    this.setState({ isLoaded: false, disableConsentButton: true });
    const plainText = this.state.aadhaarNumber;

    try {
      const encryptedText = await this.encryptText(
        plainText,
        this.state.publicKeyPem
      );
      postAuthenticatedABDMData(
        "POST",
        abdmM1URL + "/v3/enrollment/request/otp",
        {
          scope: ["abha-enrol"],
          loginHint: "aadhaar",
          loginId: encryptedText,
          otpSystem: "aadhaar"
        },
        {},
        { patientConsentGranted: true }
      ).then(res => {
        if (res.status.statusCode === "OK") {
          toast.success(
            "Please enter 6-digit OTP sent to Aadhaar linked mobile number below to proceed with Aadhaar creation. " +
              res.data.message +
              "."
          );
          this.goToNextPage();
          this.startOtpTimer();
          this.setState({ isLoaded: true, txnId: res.data.txnId });
        } else {
          if (res.status.message.includes("ABDM-1204")) {
            toast.error("Too many attempts. Please try again later.");
          } else {
            toast.error("The Aadhaar Number provided is invalid");
          }
          this.setState({ disableConsentButton: false, isLoaded: true });
        }
      });
    } catch (error) {
      this.setState({ isLoaded: true, disableButton: false });
      toast.error("Error in encrypting your data.");
    }
  }

  startABDMFlow() {
    this.setState({ abdm: true });
    this.setState({ currentPage: 4 });
  }

  goToNextPage() {
    this.setState({ currentPage: this.state.currentPage + 1 });
  }

  componentDidMount() {
    this.setState({ collapsed: true });
    this.modal.current.scrollTo(0, 0);
    //eslint-disable-next-line
    console.log(this.i18n.language);

    if (
      sessionStorage.getItem("domain") ===
        "https://remidio-backend-staging.appspot.com" ||
      sessionStorage.getItem("domain") ===
        "https://remidio-backend-india.appspot.com"
    ) {
      postAuthenticatedABDMData(
        "GET",
        abdmM1URL + "/v3/profile/public/certificate"
      ).then(res => {
        this.setState({ publicKeyPem: res.data.publicKey });
      });
    }

    // Initial validation check
    this.setState({
      disableFirstButton: !this.validateRequiredFields()
    });
  }
  /**
   * Handles changes to the device selection in the form
   *
   *
   * @param {object} e      event listener
   */
  onChange(e) {
    // Handle site change and refresh custom fields
    if (e.target.name === "site") {
      const newSiteId = e.target.value;

      // Find the selected site from props
      const selectedSite = this.props.sites.find(
        site => site.siteId.toString() === newSiteId
      );

      // Extract custom fields from the selected site's configuration
      let customFields = [];
      let customFieldValues = {};

      if (
        selectedSite &&
        selectedSite.configurations &&
        selectedSite.configurations.CUSTOM_FIELDS &&
        selectedSite.configurations.CUSTOM_FIELDS.length > 0
      ) {
        try {
          // Parse the custom fields JSON string
          const customFieldsValue =
            selectedSite.configurations.CUSTOM_FIELDS[0].value;
          customFields = JSON.parse(customFieldsValue);

          // Initialize custom field values for the new site's fields
          customFields.forEach(field => {
            customFieldValues[field.id] =
              field.type === "picker"
                ? ""
                : field.type === "number"
                ? ""
                : field.type === "date"
                ? null
                : "";
          });
        } catch (error) {
          console.error("Error parsing custom fields for site:", error);
          customFields = [];
          customFieldValues = {};
        }
      }

      // Update state with new site and custom fields, then validate
      this.setState(
        {
          site: newSiteId,
          customFields: customFields,
          customFieldValues: customFieldValues
        },
        () => {
          // Validate after state update
          this.setState({
            disableFirstButton: !this.validateRequiredFields()
          });
        }
      );

      return; // Exit early for site selection
    }

    // Handle ABHA Number field
    if (e.target.name === "abhaNumber") {
      if (e.target.value === "" || /^[0-9-]+$/.test(e.target.value)) {
        this.setState(
          {
            [e.target.name]: e.target.value
          },
          () => {
            this.setState({
              disableFirstButton: !this.validateRequiredFields()
            });
          }
        );
      }
      return;
    }

    // Handle Aadhaar Number field
    if (e.target.name === "aadhaarNumber") {
      if (e.target.value === "" || /^[0-9]+$/.test(e.target.value)) {
        this.setState(
          {
            [e.target.name]: e.target.value
          },
          () => {
            this.setState({
              disableFirstButton: !this.validateRequiredFields()
            });
          }
        );
      }
      return;
    }

    // Handle Phone Number field
    if (e.target.name === "phoneNumber") {
      if (e.target.value === "" || /^[0-9]+$/.test(e.target.value)) {
        this.setState(
          {
            [e.target.name]: e.target.value
          },
          () => {
            this.setState({
              disableFirstButton: !this.validateRequiredFields()
            });
          }
        );
      }
      return;
    }

    // Handle other fields (existing logic)
    if (
      e.target.name !== "age" &&
      (e.target.name !== "mrn" ||
        !/[ !@#$%^&*()_+\=\[\]{};':"\\|,.<>\/?]/g.test(e.target.value))
    ) {
      this.setState(
        {
          [e.target.name]: e.target.value
        },
        () => {
          this.setState({
            disableFirstButton: !this.validateRequiredFields(),
            disableSecondButton:
              this.state.doctorfirstname === "" ||
              this.state.doctorlastname === "" ||
              this.state.doctoremail === ""
          });
        }
      );
    } else {
      if (
        (e.target.name === "age" && e.target.value === "") ||
        (e.target.name === "age" && parseInt(e.target.value) < 100)
      ) {
        this.setState(
          {
            [e.target.name]: e.target.value
          },
          () => {
            this.setState({
              disableFirstButton: !this.validateRequiredFields(),
              disableSecondButton:
                this.state.doctorfirstname === "" ||
                this.state.doctorlastname === "" ||
                this.state.doctoremail === "",
              startDate: new Date(
                new Date().getFullYear() - this.state.age,
                0,
                1
              ).getTime()
            });
          }
        );
      }
    }

    // Handle ABHA Address validation
    if (e.target.name === "abhaAddress") {
      const validation = this.validateAbhaAddress(e.target.value);
      this.setState({
        abhaAddressValidation: validation,
        disableAbhaAddressButton: !validation.isValid
      });
    }
  }

  expand() {
    this.setState({ collapsed: false }, () => {
      this.modal.current.scrollTo(0, this.modal.current.scrollHeight);
    });
  }

  collapse() {
    this.setState({ collapsed: true });
  }
  handleChange(e) {
    switch (e.currentTarget.name) {
      case "editfop":
        if (!e.currentTarget.checked) {
          this.setState(
            {
              editDeviceType: this?.state?.editDeviceType?.filter?.(
                e => e !== "FOP"
              )
            },
            () => {
              this.setState({
                disableFirstButton: !this.validateRequiredFields(),
                disableSecondButton:
                  this.state.doctorfirstname === "" ||
                  this.state.doctorlastname === "" ||
                  this.state.doctoremail === ""
              });
            }
          );
        } else {
          this.setState(
            {
              editDeviceType: [
                ...this.state.editDeviceType.filter?.(e => e !== "PRISTINE"),
                "FOP"
              ]
            },
            () => {
              this.setState({
                disableFirstButton: !this.validateRequiredFields(),
                disableSecondButton:
                  this.state.doctorfirstname === "" ||
                  this.state.doctorlastname === "" ||
                  this.state.doctoremail === ""
              });
            }
          );
        }
        break;
      case "editpsl":
        if (!e.currentTarget.checked) {
          this.setState(
            {
              editDeviceType: this?.state?.editDeviceType?.filter?.(
                e => e !== "PSL"
              )
            },
            () => {
              this.setState({
                disableFirstButton: !this.validateRequiredFields(),
                disableSecondButton:
                  this.state.doctorfirstname === "" ||
                  this.state.doctorlastname === "" ||
                  this.state.doctoremail === ""
              });
            }
          );
        } else {
          this.setState(
            {
              editDeviceType: [
                ...this.state.editDeviceType.filter?.(e => e !== "PRISTINE"),
                "PSL"
              ]
            },
            () => {
              this.setState({
                disableFirstButton: !this.validateRequiredFields(),
                disableSecondButton:
                  this.state.doctorfirstname === "" ||
                  this.state.doctorlastname === "" ||
                  this.state.doctoremail === ""
              });
            }
          );
        }
        break;
      case "editaim":
        if (!e.currentTarget.checked) {
          this.setState(
            {
              editDeviceType: this?.state?.editDeviceType?.filter?.(
                e => e !== "AIM"
              )
            },
            () => {
              this.setState({
                disableFirstButton: !this.validateRequiredFields(),
                disableSecondButton:
                  this.state.doctorfirstname === "" ||
                  this.state.doctorlastname === "" ||
                  this.state.doctoremail === ""
              });
            }
          );
        } else {
          this.setState(
            {
              editDeviceType: [
                ...this.state.editDeviceType.filter?.(e => e !== "PRISTINE"),
                "AIM"
              ]
            },
            () => {
              this.setState({
                disableFirstButton: !this.validateRequiredFields(),
                disableSecondButton:
                  this.state.doctorfirstname === "" ||
                  this.state.doctorlastname === "" ||
                  this.state.doctoremail === ""
              });
            }
          );
        }
        break;
      case "editinstaref":
        if (!e.currentTarget.checked) {
          this.setState(
            {
              editDeviceType: this?.state?.editDeviceType?.filter?.(
                e => e !== "INSTAREF"
              )
            },
            () => {
              this.setState({
                disableFirstButton: !this.validateRequiredFields(),
                disableSecondButton:
                  this.state.doctorfirstname === "" ||
                  this.state.doctorlastname === "" ||
                  this.state.doctoremail === ""
              });
            }
          );
        } else {
          this.setState(
            {
              editDeviceType: [
                ...this.state.editDeviceType.filter?.(e => e !== "PRISTINE"),
                "INSTAREF"
              ]
            },
            () => {
              this.setState({
                disableFirstButton: !this.validateRequiredFields(),
                disableSecondButton:
                  this.state.doctorfirstname === "" ||
                  this.state.doctorlastname === "" ||
                  this.state.doctoremail === ""
              });
            }
          );
        }
        break;
      case "editinstaz":
        if (!e.currentTarget.checked) {
          this.setState(
            {
              editDeviceType: this?.state?.editDeviceType?.filter?.(
                e => e !== "INSTAZ"
              )
            },
            () => {
              this.setState({
                disableFirstButton: !this.validateRequiredFields(),
                disableSecondButton:
                  this.state.doctorfirstname === "" ||
                  this.state.doctorlastname === "" ||
                  this.state.doctoremail === ""
              });
            }
          );
        } else {
          this.setState(
            {
              editDeviceType: [
                ...this.state.editDeviceType.filter?.(e => e !== "PRISTINE"),
                "INSTAZ"
              ]
            },
            () => {
              this.setState({
                disableFirstButton: !this.validateRequiredFields(),
                disableSecondButton:
                  this.state.doctorfirstname === "" ||
                  this.state.doctorlastname === "" ||
                  this.state.doctoremail === ""
              });
            }
          );
        }
        break;
      case "editinstazm":
        if (!e.currentTarget.checked) {
          this.setState(
            {
              editDeviceType: this?.state?.editDeviceType?.filter?.(
                e => e !== "INSTAZM"
              )
            },
            () => {
              this.setState({
                disableFirstButton: !this.validateRequiredFields(),
                disableSecondButton:
                  this.state.doctorfirstname === "" ||
                  this.state.doctorlastname === "" ||
                  this.state.doctoremail === ""
              });
            }
          );
        } else {
          this.setState(
            {
              editDeviceType: [
                ...this.state.editDeviceType.filter?.(e => e !== "PRISTINE"),
                "INSTAZM"
              ]
            },
            () => {
              this.setState({
                disableFirstButton: !this.validateRequiredFields(),
                disableSecondButton:
                  this.state.doctorfirstname === "" ||
                  this.state.doctorlastname === "" ||
                  this.state.doctoremail === ""
              });
            }
          );
        }
        break;
      case "editpristine":
        if (!e.currentTarget.checked) {
          this.setState(
            {
              editDeviceType: this?.state?.editDeviceType?.filter?.(
                e => e !== "PRISTINE"
              )
            },
            () => {
              this.setState({
                disableFirstButton: !this.validateRequiredFields(),
                disableSecondButton:
                  this.state.doctorfirstname === "" ||
                  this.state.doctorlastname === "" ||
                  this.state.doctoremail === ""
              });
            }
          );
        } else {
          this.setState(
            {
              editDeviceType: ["PRISTINE"]
            },
            () => {
              this.setState({
                disableFirstButton: !this.validateRequiredFields(),
                disableSecondButton:
                  this.state.doctorfirstname === "" ||
                  this.state.doctorlastname === "" ||
                  this.state.doctoremail === ""
              });
            }
          );
        }
        break;
      case "editinstakc":
        if (!e.currentTarget.checked) {
          this.setState(
            {
              editDeviceType: this?.state?.editDeviceType?.filter?.(
                e => e !== "INSTAKC"
              )
            },
            () => {
              this.setState({
                disableFirstButton: !this.validateRequiredFields(),
                disableSecondButton:
                  this.state.doctorfirstname === "" ||
                  this.state.doctorlastname === "" ||
                  this.state.doctoremail === ""
              });
            }
          );
        } else {
          this.setState(
            {
              editDeviceType: [
                ...this.state.editDeviceType.filter?.(e => e !== "PRISTINE"),
                "INSTAKC"
              ]
            },
            () => {
              this.setState({
                disableFirstButton: !this.validateRequiredFields(),
                disableSecondButton:
                  this.state.doctorfirstname === "" ||
                  this.state.doctorlastname === "" ||
                  this.state.doctoremail === ""
              });
            }
          );
        }
        break;
      case "editneubo":
        if (!e.currentTarget.checked) {
          this.setState(
            {
              editDeviceType: this?.state?.editDeviceType?.filter?.(
                e => e !== "NEUBO"
              )
            },
            () => {
              this.setState({
                disableFirstButton: !this.validateRequiredFields(),
                disableSecondButton:
                  this.state.doctorfirstname === "" ||
                  this.state.doctorlastname === "" ||
                  this.state.doctoremail === ""
              });
            }
          );
        } else {
          this.setState(
            {
              editDeviceType: [
                ...this.state.editDeviceType.filter?.(e => e !== "PRISTINE"),
                "NEUBO"
              ]
            },
            () => {
              this.setState({
                disableFirstButton: !this.validateRequiredFields(),
                disableSecondButton:
                  this.state.doctorfirstname === "" ||
                  this.state.doctorlastname === "" ||
                  this.state.doctoremail === ""
              });
            }
          );
        }
        break;
      case "editobm":
        if (!e.currentTarget.checked) {
          this.setState(
            {
              editDeviceType: this?.state?.editDeviceType?.filter?.(
                e => e !== "OBM"
              )
            },
            () => {
              this.setState({
                disableFirstButton: !this.validateRequiredFields(),
                disableSecondButton:
                  this.state.doctorfirstname === "" ||
                  this.state.doctorlastname === "" ||
                  this.state.doctoremail === ""
              });
            }
          );
        } else {
          this.setState(
            {
              editDeviceType: [
                ...this.state.editDeviceType.filter?.(e => e !== "PRISTINE"),
                "OBM"
              ]
            },
            () => {
              this.setState({
                disableFirstButton: !this.validateRequiredFields(),
                disableSecondButton:
                  this.state.doctorfirstname === "" ||
                  this.state.doctorlastname === "" ||
                  this.state.doctoremail === ""
              });
            }
          );
        }
        break;
      case "editother":
        if (!e.currentTarget.checked) {
          this.setState(
            {
              editDeviceType: this?.state?.editDeviceType?.filter?.(
                e => e !== "OTHER"
              )
            },
            () => {
              this.setState({
                disableFirstButton: !this.validateRequiredFields(),
                disableSecondButton:
                  this.state.doctorfirstname === "" ||
                  this.state.doctorlastname === "" ||
                  this.state.doctoremail === ""
              });
            }
          );
        } else {
          this.setState(
            {
              editDeviceType: [
                ...this.state.editDeviceType.filter?.(e => e !== "PRISTINE"),
                "OTHER"
              ]
            },
            () => {
              this.setState({
                disableFirstButton: !this.validateRequiredFields(),
                disableSecondButton:
                  this.state.doctorfirstname === "" ||
                  this.state.doctorlastname === "" ||
                  this.state.doctoremail === ""
              });
            }
          );
        }
        break;
    }
  }
  /**
   * Triggered when a date is selected, and updates the state accordingly
   *
   *
   * @param {object} date      selected date
   */
  dateChange(date) {
    this.setState(
      {
        startDate: date?.getTime()
      },
      () => {
        this.setState({
          disableFirstButton: !this.validateRequiredFields(),
          disableSecondButton:
            this.state.doctorfirstname === "" ||
            this.state.doctorlastname === "" ||
            this.state.doctoremail === "",
          age: isNaN(differenceInYears(new Date().getTime(), date?.getTime()))
            ? ""
            : differenceInYears(new Date().getTime(), date?.getTime())
        });
      }
    );
  }
  /**
   * Proceeds to the second page
   *
   *
   */
  onFirstPageProceed() {
    this.setState({ currentPage: 2 });
  }
  /**
   * Proceeds to the third page
   *
   *
   */
  onSecondPageProceed() {
    this.setState({ currentPage: 3 });
  }
  /**
   * Gets triggered on pressing the submit button, constructs the object, and submits the API call
   *
   *
   */
  onSubmit() {
    // Check if this is ABDM flow and we should check for existing patient
    if (this.state.abdm && this.state.linkingFlow) {
      this.setState({ isLoaded: false });

      this.checkExistingPatient()
        .then(result => {
          if (
            result.status &&
            result.status.statusCode === "OK" &&
            result.data &&
            result.data.patient
          ) {
            // Patient exists, store original data and prepare for comparison
            const originalPatient = result.data.patient;

            const newPatientData = {
              mrn: this.state.mrn,
              firstName: this.state.firstname,
              lastName: this.state.lastname,
              gender: this.state.gender,
              dateOfBirth: this.state.startDate,
              phoneNumber: this.state.phoneNumber,
              abhaNumber: this.state.abhaNumber,
              abhaAddress: this.state.abhaAddress,
              address: this.state.address,
              district: this.state.districtName,
              state: this.state.stateName,
              pinCode: this.state.pinCode
            };

            this.setState({
              originalPatientData: originalPatient,
              newPatientData: newPatientData,
              showComparison: true,
              currentPage: 16, // New comparison page
              isLoaded: true
            });
          } else if (
            result.status &&
            result.status.statusCode === "NOT_FOUND"
          ) {
            // Patient doesn't exist, proceed with normal submission
            this.setState({ isLoaded: true }, () => {
              this.submitForm();
            });
          } else {
            // Other error, proceed with normal submission
            this.setState({ isLoaded: true }, () => {
              this.submitForm();
            });
          }
        })
        .catch(() => {
          // Error in API call, proceed with normal submission
          this.setState({ isLoaded: true }, () => {
            this.submitForm();
          });
        });
    } else {
      // Regular flow or ABDM creation flow, submit directly
      this.submitForm();
    }
  }

  handleSubmit(event) {
    event.preventDefault();
  }
  /**
   * Goes to the first page
   *
   *
   */
  goToFirstPage() {
    this.setState({
      currentPage: 1,
      isLoaded: true,
      disableFirstButton: false,
      collapsed: false
    });
  }
  goToSecondPage() {
    this.setState({ currentPage: 2 });
  }

  // Add this method to the class
  maskAadhaar = value => {
    if (!value) return value;
    return value.replace(/(\d{8})(\d{4})/, "XXXXXXXX$2");
  };

  // Add this method to handle blur
  handleAadhaarBlur = e => {
    const value = e.target.value;
    if (value.length === 12) {
      const maskedValue = "XXXX-XXXX-" + value.slice(-4);
      this.setState({
        aadhaarNumber: value, // Keep original value in state
        maskedAadhaar: maskedValue // Store masked version
      });
    }
  };

  // Add validation methods
  validateAbhaAddress = value => {
    const minLength = value.length >= 8;
    const maxLength = value.length <= 18;

    // 5) Ensure only letters, numbers, dot, and underscore are used
    const onlyAllowedChars = /^[A-Za-z0-9._]+$/.test(value);

    // 4) Dot or underscore should not be at the beginning or end
    //    i.e., the string shouldn't start or end with '.' or '_'
    const noSpecialStartEnd = !/^[._]|[._]$/.test(value);

    // 3) Count how many dots and underscores there are
    const dotCount = (value.match(/\./g) || []).length;
    const underscoreCount = (value.match(/_/g) || []).length;
    const singleDot = dotCount <= 1;
    const singleUnderscore = underscoreCount <= 1;

    // Final validity check
    const isValid =
      minLength &&
      maxLength &&
      onlyAllowedChars &&
      noSpecialStartEnd &&
      singleDot &&
      singleUnderscore;

    // Return an object with all checks, plus an overall "isValid"
    return {
      minLength,
      maxLength,
      onlyAllowedChars,
      noSpecialStartEnd,
      singleDot,
      singleUnderscore,
      isValid
    };
  };

  validateRequiredFields() {
    // Basic required field validation
    const basicFieldsValid =
      this.state.mrn !== "" &&
      this.state.firstname !== "" &&
      this.state.editDeviceType.length > 0 &&
      this.state.startDate;

    // Custom fields validation
    let customFieldsValid = true;
    if (this.state.customFields && this.state.customFields.length > 0) {
      customFieldsValid = this.state.customFields.every(field => {
        if (!field.required) return true; // Skip non-required fields

        const value = this.state.customFieldValues[field.id];

        // Check if field has a value based on its type
        switch (field.type) {
          case "text":
          case "picker":
            return value !== "" && value !== null && value !== undefined;
          case "number":
            return (
              value !== "" &&
              value !== null &&
              value !== undefined &&
              !isNaN(value)
            );
          case "date":
            return value !== null && value !== undefined;
          default:
            return value !== "" && value !== null && value !== undefined;
        }
      });
    }

    return basicFieldsValid && customFieldsValid;
  }

  render() {
    // Add validation display component
    const AbhaAddressValidation = () => {
      return (
        <div className="validation-errors">
          {!this.state.abhaAddressValidation.minLength && (
            <p className="error">
              <span className="cross"> x </span> Minimum length should be 8
              characters
            </p>
          )}
          {this.state.abhaAddressValidation.minLength && (
            <p className="check-valid">
              <span className="cross"> ✓ </span>
              ABHA Address passes the minimum length check.
            </p>
          )}
          {!this.state.abhaAddressValidation.maxLength && (
            <p className="error">
              <span className="cross"> x </span> Maximum length should be 18
              characters
            </p>
          )}
          {this.state.abhaAddressValidation.maxLength && (
            <p className="check-valid">
              <span className="cross"> ✓ </span>
              ABHA Address passes the maximum length check.
            </p>
          )}
          {!this.state.abhaAddressValidation.onlyAllowedChars && (
            <p className="error">
              <span className="cross"> x </span> Only alphabets, numbers, dot(.)
              and underscore(_) are allowed
            </p>
          )}
          {this.state.abhaAddressValidation.onlyAllowedChars && (
            <p className="check-valid">
              <span className="cross"> ✓ </span>
              All the characters are valid characters
            </p>
          )}
          {!this.state.abhaAddressValidation.noSpecialStartEnd && (
            <p className="error">
              <span className="cross"> x </span> Cannot start or end with a
              dot(.) or underscore(_)
            </p>
          )}
          {this.state.abhaAddressValidation.noSpecialStartEnd && (
            <p className="check-valid">
              <span className="cross"> ✓ </span>
              Does not start or end with a dot (.) or underscore (_)
            </p>
          )}
          {!this.state.abhaAddressValidation.singleDot && (
            <p className="error">
              <span className="cross"> x </span> Not more than one dot (.)
              should be present
            </p>
          )}
          {this.state.abhaAddressValidation.singleDot && (
            <p className="check-valid">
              <span className="cross"> ✓ </span>
              ABHA Address passes the dot check
            </p>
          )}
          {!this.state.abhaAddressValidation.singleUnderscore && (
            <p className="error">
              <span className="cross"> x </span> Not more than one underscore
              (_) should be present
            </p>
          )}
          {this.state.abhaAddressValidation.singleUnderscore && (
            <p className="check-valid">
              <span className="cross"> ✓ </span>
              ABHA Address passes the underscore check
            </p>
          )}
        </div>
      );
    };

    return (
      <div className="custommodal">
        <div
          className="custommodalinner custommodalinnerdatepicker"
          ref={this.modal}
        >
          {(() => {
            if (this.state.currentPage === 2) {
              return (
                <a className="add-org-back" onClick={this.goToFirstPage}>
                  &lt; {this.t(T_GENERAL.back)}
                </a>
              );
            }
          })()}
          {(() => {
            if (this.state.currentPage === 3) {
              return (
                <a className="add-org-back" onClick={this.goToSecondPage}>
                  &lt; {this.t(T_GENERAL.back)}
                </a>
              );
            }
          })()}
          <form
            autoComplete="off"
            className="loginpad custom-add-exam-patient-modal"
            onSubmit={this.handleSubmit}
          >
            <h6 className="modal-heading">{this.t(T_EXAMS.addExam.header)}</h6>
            <Button
              // eslint-disable-next-line react/prop-types
              onClick={this.props.closePopup}
              className="cancle"
            >
              {" "}
              x{" "}
            </Button>
            <hr className="hrpadding" />
            {(() => {
              if (this.state.currentPage === 1) {
                return (
                  <div className="firstpage">
                    {(sessionStorage.getItem("domain") ===
                      "https://remidio-backend-staging.appspot.com" ||
                      sessionStorage.getItem("domain") ===
                        "https://remidio-backend-india.appspot.com") &&
                      !this.state.abdm && (
                        <>
                          <Button
                            onClick={this.startABDMFlow}
                            className="loginbtn1 create-account-btn abdm-button"
                          >
                            {this.t(T_PATIENTS.addPatient.registerWithAbha)}
                          </Button>
                          <div className="separator">
                            <div className="line"></div>
                            <span className="or-text">
                              {this.t(T_PATIENTS.addPatient.or)}
                            </span>
                            <div className="line"></div>
                          </div>
                        </>
                      )}
                    <FormGroup controlId="email" bsSize="large">
                      <div className="row">
                        <div className="col-md-3 formfont">
                          {this.t(T_ENTITIES.exam.site)}*
                        </div>
                        <div className="col-md-9">
                          <select
                            name="site"
                            onChange={this.onChange}
                            value={this.state.site}
                          >
                            {this.props.sites?.map(e => (
                              <option value={e?.siteId} key={e?.siteId}>
                                {e?.siteName}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </FormGroup>
                    <h6 className="exam-heading">
                      {this.t(T_EXAMS.addExam.patient)}
                    </h6>
                    {this.state.abdm && (
                      <FormGroup controlId="name" bsSize="medium">
                        <div className="row">
                          <div className="col-md-3 formfont">ABHA Number*</div>
                          <div className="col-md-9">
                            <FormControl
                              autoFocus
                              required
                              disabled
                              type="text"
                              name="abhaNumber"
                              maxLength={20}
                              value={this.state.abhaNumber}
                              onChange={this.onChange}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    )}
                    {this.state.abdm && (
                      <>
                        <FormGroup controlId="name" bsSize="medium">
                          <div className="row">
                            <div className="col-md-3 formfont">
                              ABHA Address*
                            </div>
                            <div className="col-md-9">
                              <FormControl
                                autoFocus
                                required
                                disabled
                                type="text"
                                name="abhaAddress"
                                maxLength={20}
                                value={this.state.abhaAddress}
                                onChange={this.onChange}
                              />
                            </div>
                          </div>
                        </FormGroup>
                      </>
                    )}
                    {this.state.abdm && (
                      <>
                        <FormGroup controlId="name" bsSize="medium">
                          <div className="row">
                            <div className="col-md-3 formfont">Address*</div>
                            <div className="col-md-9">
                              <FormControl
                                autoFocus
                                required
                                disabled
                                type="text"
                                name="address"
                                value={this.state.address}
                                onChange={this.onChange}
                              />
                            </div>
                          </div>
                        </FormGroup>
                      </>
                    )}
                    {this.state.abdm && (
                      <>
                        <FormGroup controlId="name" bsSize="medium">
                          <div className="row">
                            <div className="col-md-3 formfont">District*</div>
                            <div className="col-md-9">
                              <FormControl
                                autoFocus
                                required
                                disabled
                                type="text"
                                name="districtName"
                                value={this.state.districtName}
                                onChange={this.onChange}
                              />
                            </div>
                          </div>
                        </FormGroup>
                      </>
                    )}
                    {this.state.abdm && (
                      <>
                        <FormGroup controlId="name" bsSize="medium">
                          <div className="row">
                            <div className="col-md-3 formfont">State*</div>
                            <div className="col-md-9">
                              <FormControl
                                autoFocus
                                required
                                disabled
                                type="text"
                                name="stateName"
                                value={this.state.stateName}
                                onChange={this.onChange}
                              />
                            </div>
                          </div>
                        </FormGroup>
                      </>
                    )}
                    {this.state.abdm && (
                      <>
                        <FormGroup controlId="name" bsSize="medium">
                          <div className="row">
                            <div className="col-md-3 formfont">Pin Code*</div>
                            <div className="col-md-9">
                              <FormControl
                                autoFocus
                                required
                                disabled
                                type="text"
                                name="pinCode"
                                value={this.state.pinCode}
                                onChange={this.onChange}
                              />
                            </div>
                          </div>
                        </FormGroup>
                      </>
                    )}
                    {this.state.abdm &&
                      this.state.linkingFlow &&
                      this.state.abhaCardAvailable && (
                        <Button
                          onClick={() => this.downloadAbha()}
                          className="create-account-btn download-abha-btn abha-card-btn"
                        >
                          Download ABHA Card
                        </Button>
                      )}
                    <FormGroup controlId="name" bsSize="medium">
                      <div className="row">
                        <div className="col-md-3 formfont">
                          {this.t(T_ENTITIES.patient.mrn)}*
                        </div>
                        <div className="col-md-9">
                          <FormControl
                            autoFocus
                            required
                            type="text"
                            name="mrn"
                            maxLength={22}
                            pattern="[a-zA-Z0-9]+"
                            value={this.state.mrn}
                            onChange={this.onChange}
                          />
                        </div>
                      </div>
                    </FormGroup>

                    <FormGroup controlId="email" bsSize="large">
                      <div className="row">
                        <div className="col-md-3 formfont">
                          {this.t(T_ENTITIES.patient.firstName)}*
                        </div>
                        <div className="col-md-9">
                          <FormControl
                            required
                            type="text"
                            name="firstname"
                            disabled={this.state.abdm}
                            maxLength={30}
                            value={this.state.firstname}
                            onChange={this.onChange}
                          />
                        </div>
                      </div>
                    </FormGroup>

                    <FormGroup controlId="email" bsSize="large">
                      <div className="row">
                        <div className="col-md-3 formfont">
                          {this.t(T_ENTITIES.patient.lastName)}
                        </div>
                        <div className="col-md-9">
                          <FormControl
                            required
                            type="text"
                            name="lastname"
                            disabled={this.state.abdm}
                            maxLength={30}
                            value={this.state.lastname}
                            onChange={this.onChange}
                          />
                        </div>
                      </div>
                    </FormGroup>
                    <FormGroup controlId="email" bsSize="large">
                      <div className="row">
                        <div className="col-md-3 formfont">
                          {this.t(T_ENTITIES.patient.gender)}*
                        </div>
                        <div className="col-md-9">
                          <select
                            name="gender"
                            disabled={this.state.abdm}
                            value={this.state.gender}
                            onChange={this.onChange}
                          >
                            <option value="MALE" key="MALE">
                              {this.t(T_ENTITIES.patient.genderTypes.male)}
                            </option>
                            <option value="FEMALE" key="FEMALE">
                              {this.t(T_ENTITIES.patient.genderTypes.female)}
                            </option>
                          </select>
                        </div>
                      </div>
                    </FormGroup>
                    <div className="new-dob">
                      <div className="row">
                        <div className="col-md-3 formfont">
                          {this.t(T_ENTITIES.patient.dateOfBirth)}*
                        </div>
                        <div className="col-md-3">
                          <div className="customDatePicker">
                            <DatePicker
                              selected={this.state.startDate}
                              onChange={this.dateChange}
                              disabled={this.state.abdm}
                              minDate={subYears(new Date(), 100)}
                              maxDate={new Date()}
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              locale={this.i18n.language}
                            />
                          </div>
                        </div>
                        <span className="col-md-3 or-word">
                          {this.t(T_EXAMS.addExam.or)}
                        </span>
                        <div className="col-md-1 formfont">
                          {this.t(T_ENTITIES.patient.age)}*
                        </div>
                        <div className="col-md-2">
                          <FormControl
                            required
                            type="text"
                            disabled={this.state.abdm}
                            name="age"
                            value={this.state.age}
                            onChange={this.onChange}
                          />
                        </div>
                      </div>
                    </div>
                    {(sessionStorage.getItem("domain") ===
                      "https://remidio-backend-staging.appspot.com" ||
                      sessionStorage.getItem("domain") ===
                        "https://remidio-backend-india.appspot.com") && (
                      <FormGroup controlId="name" bsSize="medium">
                        <div className="row">
                          <div className="col-md-3 formfont">Phone Number</div>
                          <div className="col-md-1 phonePrefix">+91</div>
                          <div className="col-md-7">
                            <FormControl
                              autoFocus
                              required
                              disabled={
                                this.state.abdm && this.state.phoneNumber !== ""
                              }
                              type="text"
                              name="phoneNumber"
                              maxLength={10}
                              value={this.state.phoneNumber}
                              onChange={this.onChange}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    )}
                    {this.renderCustomFields("patient")}
                    <h6 className="exam-heading">
                      {this.t(T_EXAMS.addExam.exam)}
                    </h6>
                    <FormGroup controlId="email" bsSize="large">
                      <div className="row formfont">
                        <div className="col-md-3 formfont">
                          {this.t(T_ENTITIES.exam.deviceType)}*
                        </div>
                        <div className="checkbox">
                          <FormControl
                            className="check"
                            type="checkbox"
                            name="editfop"
                            checked={this?.state?.editDeviceType?.includes?.(
                              "FOP"
                            )}
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="checkbox-label formfont">
                          {this.t(T_ENTITIES.exam.deviceTypes.fop)}
                        </div>
                        <div className="checkbox">
                          <FormControl
                            className="check"
                            type="checkbox"
                            name="editpsl"
                            checked={this?.state?.editDeviceType?.includes?.(
                              "PSL"
                            )}
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="checkbox-label formfont">
                          {this.t(T_ENTITIES.exam.deviceTypes.psl)}
                        </div>
                        <div className="checkbox">
                          <FormControl
                            className="check"
                            type="checkbox"
                            name="editaim"
                            checked={this?.state?.editDeviceType?.includes?.(
                              "AIM"
                            )}
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="checkbox-label formfont">
                          {this.t(T_ENTITIES.exam.deviceTypes.aim)}
                        </div>
                        <div className="checkbox">
                          <FormControl
                            className="check"
                            type="checkbox"
                            name="editinstaref"
                            checked={this?.state?.editDeviceType?.includes?.(
                              "INSTAREF"
                            )}
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="checkbox-label formfont">
                          {this.t(T_ENTITIES.exam.deviceTypes.instaref)}
                        </div>
                        <div className="checkbox">
                          <FormControl
                            className="check"
                            type="checkbox"
                            name="editinstaz"
                            checked={this?.state?.editDeviceType?.includes?.(
                              "INSTAZ"
                            )}
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="checkbox-label formfont">
                          {this.t(T_ENTITIES.exam.deviceTypes.instaz)}
                        </div>
                        <div className="checkbox">
                          <FormControl
                            className="check"
                            type="checkbox"
                            name="editinstazm"
                            checked={this?.state?.editDeviceType?.includes?.(
                              "INSTAZM"
                            )}
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="checkbox-label formfont">
                          {this.t(T_ENTITIES.exam.deviceTypes.instazm)}
                        </div>
                        <div className="checkbox">
                          <FormControl
                            className="check"
                            type="checkbox"
                            name="editpristine"
                            checked={this?.state?.editDeviceType?.includes?.(
                              "PRISTINE"
                            )}
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="checkbox-label formfont">
                          {this.t(T_ENTITIES.exam.deviceTypes.pristine)}
                        </div>
                        <div className="checkbox">
                          <FormControl
                            className="check"
                            type="checkbox"
                            name="editinstaz"
                            checked={this?.state?.editDeviceType?.includes?.(
                              "INSTAZ"
                            )}
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="checkbox-label formfont">
                          {this.t(T_ENTITIES.exam.deviceTypes.instaz)}
                        </div>
                        <div className="checkbox">
                          <FormControl
                            className="check"
                            type="checkbox"
                            name="editinstazm"
                            checked={this?.state?.editDeviceType?.includes?.(
                              "INSTAZM"
                            )}
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="checkbox-label formfont">
                          {this.t(T_ENTITIES.exam.deviceTypes.instazm)}
                        </div>
                        <div className="checkbox">
                          <FormControl
                            className="check"
                            type="checkbox"
                            name="editinstakc"
                            checked={this?.state?.editDeviceType?.includes?.(
                              "INSTAKC"
                            )}
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="checkbox-label formfont">
                          {this.t(T_ENTITIES.exam.deviceTypes.instakc)}
                        </div>
                        <div className="checkbox">
                          <FormControl
                            className="check"
                            type="checkbox"
                            name="editneubo"
                            checked={this?.state?.editDeviceType?.includes?.(
                              "NEUBO"
                            )}
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="checkbox-label formfont">
                          {this.t(T_ENTITIES.exam.deviceTypes.neubo)}
                        </div>
                        <div className="checkbox">
                          <FormControl
                            className="check"
                            type="checkbox"
                            name="editobm"
                            checked={this?.state?.editDeviceType?.includes?.(
                              "OBM"
                            )}
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="checkbox-label formfont">
                          {this.t(T_ENTITIES.exam.deviceTypes.obm)}
                        </div>
                        <div className="checkbox">
                          <FormControl
                            className="check"
                            type="checkbox"
                            name="editinstakc"
                            checked={this?.state?.editDeviceType?.includes?.(
                              "INSTAKC"
                            )}
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="checkbox-label formfont">
                          {this.t(T_ENTITIES.exam.deviceTypes.instakc)}
                        </div>
                        <div className="checkbox">
                          <FormControl
                            className="check"
                            type="checkbox"
                            name="editinstaz"
                            checked={this?.state?.editDeviceType?.includes?.(
                              "INSTAZ"
                            )}
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="checkbox-label formfont">
                          {this.t(T_ENTITIES.exam.deviceTypes.instaz)}
                        </div>
                        <div className="checkbox">
                          <FormControl
                            className="check"
                            type="checkbox"
                            name="editinstazm"
                            checked={this?.state?.editDeviceType?.includes?.(
                              "INSTAZM"
                            )}
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="checkbox-label formfont">
                          {this.t(T_ENTITIES.exam.deviceTypes.instazm)}
                        </div>
                        <div className="checkbox">
                          <FormControl
                            className="check"
                            type="checkbox"
                            name="editother"
                            checked={this?.state?.editDeviceType?.includes?.(
                              "OTHER"
                            )}
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="checkbox-label formfont">
                          {this.t(T_ENTITIES.exam.deviceTypes.other)}
                        </div>
                      </div>
                    </FormGroup>
                    <FormGroup controlId="customidentifier" bsSize="large">
                      <div className="row">
                        <div className="col-md-3 formfont">
                          {this.t(T_ENTITIES.exam.examCode)}
                        </div>
                        <div className="col-md-9">
                          <FormControl
                            required
                            type="text"
                            name="examCustomId"
                            maxLength="20"
                            value={this.state.examCustomId}
                            onChange={this.onChange}
                          />
                        </div>
                      </div>
                    </FormGroup>
                    <FormGroup controlId="email" bsSize="large">
                      <div className="row">
                        <div className="col-md-3 formfont">
                          {this.t(T_ENTITIES.exam.ocularHistory)}
                        </div>
                        <div className="col-md-9">
                          <FormControl
                            required
                            as="textarea"
                            name="ocularhistory"
                            value={this.state.ocularhistory}
                            onChange={this.onChange}
                          />
                        </div>
                      </div>
                    </FormGroup>
                    {this.renderCustomFields("exam")}
                    <div
                      className={`collapsible ${
                        this.state.collapsed ? "collapsed" : ""
                      }`}
                    >
                      <div className="col-heading">
                        <h6 className="exam-heading">
                          {this.t(T_EXAMS.addExam.prescribingDoctor)}
                        </h6>
                        {(() => {
                          if (this.state.collapsed) {
                            return (
                              <img
                                src={require("../../assets/images/plus.svg")}
                                onClick={this.expand}
                              />
                            );
                          } else {
                            return (
                              <img
                                src={require("../../assets/images/minus.svg")}
                                onClick={this.collapse}
                              />
                            );
                          }
                        })()}
                      </div>
                      <FormGroup controlId="name" bsSize="medium">
                        <div className="row">
                          <div className="col-md-3 formfont">
                            {this.t(T_EXAMS.addExam.firstName)}*
                          </div>
                          <div className="col-md-9">
                            <FormControl
                              autoFocus
                              required
                              type="text"
                              name="doctorfirstname"
                              value={this.state.doctorfirstname}
                              onChange={this.onChange}
                            />
                          </div>
                        </div>
                      </FormGroup>

                      <FormGroup controlId="email" bsSize="large">
                        <div className="row">
                          <div className="col-md-3 formfont">
                            {this.t(T_EXAMS.addExam.lastName)}
                          </div>
                          <div className="col-md-9">
                            <FormControl
                              required
                              type="text"
                              name="doctorlastname"
                              value={this.state.doctorlastname}
                              onChange={this.onChange}
                            />
                          </div>
                        </div>
                      </FormGroup>

                      <FormGroup controlId="email" bsSize="large">
                        <div className="row">
                          <div className="col-md-3 formfont">
                            {this.t(T_EXAMS.addExam.email)}*
                          </div>
                          <div className="col-md-9">
                            <FormControl
                              required
                              type="text"
                              name="doctoremail"
                              value={this.state.doctoremail}
                              onChange={this.onChange}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                    <Button
                      onClick={this.onSubmit}
                      className="loginbtn1 create-account-btn submit-button"
                      disabled={this.state.disableFirstButton}
                    >
                      {this.state.isLoaded ? (
                        this.t(T_GENERAL.submit)
                      ) : (
                        <img
                          src={require("../../assets/images/button-loading.gif")}
                        />
                      )}
                    </Button>
                  </div>
                );
              } else if (this.state.currentPage === 2) {
                return (
                  <div className="firstpage">
                    <h6>{this.t(T_EXAMS.addExam.prescribingDoctor)}*</h6>
                    <FormGroup controlId="name" bsSize="medium">
                      <div className="row">
                        <div className="col-md-3 formfont">
                          {this.t(T_EXAMS.addExam.firstName)}
                        </div>
                        <div className="col-md-9">
                          <FormControl
                            autoFocus
                            required
                            type="text"
                            name="doctorfirstname"
                            value={this.state.doctorfirstname}
                            onChange={this.onChange}
                          />
                        </div>
                      </div>
                    </FormGroup>

                    <FormGroup controlId="email" bsSize="large">
                      <div className="row">
                        <div className="col-md-3 formfont">
                          {this.t(T_EXAMS.addExam.lastName)}
                        </div>
                        <div className="col-md-9">
                          <FormControl
                            required
                            type="text"
                            name="doctorlastname"
                            value={this.state.doctorlastname}
                            onChange={this.onChange}
                          />
                        </div>
                      </div>
                    </FormGroup>

                    <FormGroup controlId="email" bsSize="large">
                      <div className="row">
                        <div className="col-md-3 formfont">
                          {this.t(T_EXAMS.addExam.email)}
                        </div>
                        <div className="col-md-9">
                          <FormControl
                            required
                            type="text"
                            name="doctoremail"
                            value={this.state.doctoremail}
                            onChange={this.onChange}
                          />
                        </div>
                      </div>
                    </FormGroup>

                    <h6>{this.t(T_EXAMS.addExam.medicalHistory)}</h6>
                    <FormGroup controlId="email" bsSize="large">
                      <div className="row">
                        <div className="col-md-3 formfont">
                          {this.t(T_EXAMS.addExam.ocularHistory)}
                        </div>
                        <div className="col-md-9">
                          <FormControl
                            required
                            as="textarea"
                            name="ocularhistory"
                            value={this.state.ocularhistory}
                            onChange={this.onChange}
                          />
                        </div>
                      </div>
                    </FormGroup>
                    <FormGroup controlId="email" bsSize="large">
                      <div className="row">
                        <div className="col-md-3 formfont">
                          {this.t(T_EXAMS.addExam.systemicHistory)}
                        </div>
                        <div className="col-md-9">
                          <FormControl
                            required
                            as="textarea"
                            name="medicalhistory"
                            value={this.state.medicalhistory}
                            onChange={this.onChange}
                          />
                        </div>
                      </div>
                    </FormGroup>
                    <FormGroup controlId="email" bsSize="large">
                      <div className="row">
                        <div className="col-md-3 formfont">
                          {this.t(T_EXAMS.addExam.currentMedication)}
                        </div>
                        <div className="col-md-9">
                          <FormControl
                            required
                            type="text"
                            name="currentmedication"
                            value={this.state.currentmedication}
                            onChange={this.onChange}
                          />
                        </div>
                      </div>
                    </FormGroup>
                    <FormGroup controlId="email" bsSize="large">
                      <div className="row">
                        <div className="col-md-3 formfont">
                          {this.t(T_EXAMS.addExam.allergies)}
                        </div>
                        <div className="col-md-9">
                          <FormControl
                            required
                            type="text"
                            name="allergies"
                            value={this.state.allergies}
                            onChange={this.onChange}
                          />
                        </div>
                      </div>
                    </FormGroup>

                    <Button
                      onClick={this.onSecondPageProceed}
                      className="loginbtn1 create-account-btn submit-button"
                      disabled={this.state.disableSecondButton}
                    >
                      {this.state.isLoaded ? (
                        this.t(T_EXAMS.addExam.proceed)
                      ) : (
                        <img
                          src={require("../../assets/images/button-loading.gif")}
                        />
                      )}
                    </Button>
                  </div>
                );
              } else if (this.state.currentPage === 3) {
                return (
                  <div className="firstpage">
                    <table className="visual-acuity-container">
                      <thead>
                        <th></th>
                        <th>{this.t(T_EXAMS.addExam.rightEye)}</th>
                        <th>{this.t(T_EXAMS.addExam.leftEye)}</th>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{this.t(T_EXAMS.addExam.ucva)}</td>
                          <td>
                            <FormGroup controlId="email" bsSize="large">
                              <FormControl
                                required
                                type="text"
                                name="rightucva"
                                value={this.state.rightucva}
                                onChange={this.onChange}
                              />
                            </FormGroup>
                          </td>
                          <td>
                            <FormGroup controlId="email" bsSize="large">
                              <FormControl
                                required
                                type="text"
                                name="leftucva"
                                value={this.state.leftucva}
                                onChange={this.onChange}
                              />
                            </FormGroup>
                          </td>
                        </tr>
                        <tr>
                          <td>{this.t(T_EXAMS.addExam.visionWithPG)}</td>
                          <td>
                            <FormGroup controlId="email" bsSize="large">
                              <FormControl
                                required
                                type="text"
                                name="rightpg"
                                value={this.state.rightpg}
                                onChange={this.onChange}
                              />
                            </FormGroup>
                          </td>
                          <td>
                            <FormGroup controlId="email" bsSize="large">
                              <FormControl
                                required
                                type="text"
                                name="leftpg"
                                value={this.state.leftpg}
                                onChange={this.onChange}
                              />
                            </FormGroup>
                          </td>
                        </tr>
                        <tr>
                          <td>{this.t(T_EXAMS.addExam.spherical)}</td>
                          <td>
                            <FormGroup controlId="email" bsSize="large">
                              <FormControl
                                required
                                type="text"
                                name="rightsph"
                                value={this.state.rightsph}
                                onChange={this.onChange}
                              />
                            </FormGroup>
                          </td>
                          <td>
                            <FormGroup controlId="email" bsSize="large">
                              <FormControl
                                required
                                type="text"
                                name="leftsph"
                                value={this.state.leftsph}
                                onChange={this.onChange}
                              />
                            </FormGroup>
                          </td>
                        </tr>
                        <tr>
                          <td>{this.t(T_EXAMS.addExam.cylindrical)}</td>
                          <td>
                            <FormGroup controlId="email" bsSize="large">
                              <FormControl
                                required
                                type="text"
                                name="rightcyl"
                                value={this.state.rightcyl}
                                onChange={this.onChange}
                              />
                            </FormGroup>
                          </td>
                          <td>
                            <FormGroup controlId="email" bsSize="large">
                              <FormControl
                                required
                                type="text"
                                name="leftcyl"
                                value={this.state.leftcyl}
                                onChange={this.onChange}
                              />
                            </FormGroup>
                          </td>
                        </tr>
                        <tr>
                          <td>{this.t(T_EXAMS.addExam.axis)}</td>
                          <td>
                            <FormGroup controlId="email" bsSize="large">
                              <FormControl
                                required
                                type="text"
                                name="rightaxis"
                                value={this.state.rightaxis}
                                onChange={this.onChange}
                              />
                            </FormGroup>
                          </td>
                          <td>
                            <FormGroup controlId="email" bsSize="large">
                              <FormControl
                                required
                                type="text"
                                name="leftaxis"
                                value={this.state.leftaxis}
                                onChange={this.onChange}
                              />
                            </FormGroup>
                          </td>
                        </tr>
                        <tr>
                          <td>{this.t(T_EXAMS.addExam.bcva)}</td>
                          <td>
                            <FormGroup controlId="email" bsSize="large">
                              <FormControl
                                required
                                type="text"
                                name="rightbcva"
                                value={this.state.rightbcva}
                                onChange={this.onChange}
                              />
                            </FormGroup>
                          </td>
                          <td>
                            <FormGroup controlId="email" bsSize="large">
                              <FormControl
                                required
                                type="text"
                                name="leftbcva"
                                value={this.state.leftbcva}
                                onChange={this.onChange}
                              />
                            </FormGroup>
                          </td>
                        </tr>
                        <tr>
                          <td>{this.t(T_EXAMS.addExam.nearAdd)}</td>
                          <td>
                            <FormGroup controlId="email" bsSize="large">
                              <FormControl
                                required
                                type="text"
                                name="rightadd"
                                value={this.state.rightadd}
                                onChange={this.onChange}
                              />
                            </FormGroup>
                          </td>
                          <td>
                            <FormGroup controlId="email" bsSize="large">
                              <FormControl
                                required
                                type="text"
                                name="leftadd"
                                value={this.state.leftadd}
                                onChange={this.onChange}
                              />
                            </FormGroup>
                          </td>
                        </tr>
                        <tr>
                          <td>{this.t(T_EXAMS.addExam.iop)}</td>
                          <td>
                            <FormGroup controlId="email" bsSize="large">
                              <FormControl
                                required
                                type="text"
                                name="rightiop"
                                value={this.state.rightiop}
                                onChange={this.onChange}
                              />
                            </FormGroup>
                          </td>
                          <td>
                            <FormGroup controlId="email" bsSize="large">
                              <FormControl
                                required
                                type="text"
                                name="leftiop"
                                value={this.state.leftiop}
                                onChange={this.onChange}
                              />
                            </FormGroup>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <Button
                      onClick={this.onSubmit}
                      className="loginbtn1 create-account-btn submit-button"
                      disabled={!this.state.isLoaded}
                    >
                      {this.state.isLoaded ? (
                        this.t(T_GENERAL.submit)
                      ) : (
                        <img
                          src={require("../../assets/images/button-loading.gif")}
                        />
                      )}
                    </Button>
                  </div>
                );
              } else if (this.state.currentPage === 4) {
                return (
                  <>
                    <p className="abha-selection-heading">
                      Choose the appropriate ABHA registration type.
                    </p>
                    <div className="abha-buttons-container">
                      <Button
                        onClick={this.startCreateFlow}
                        className="loginbtn1 create-account-btn submit-button"
                      >
                        Create New ABHA Address
                      </Button>
                      <Button
                        onClick={this.startLinkingFlow}
                        className="loginbtn1 create-account-btn submit-button"
                      >
                        Link an existing ABHA Address
                      </Button>
                      <Button
                        onClick={this.startScanningFlow}
                        className="loginbtn1 create-account-btn submit-button"
                      >
                        List all scanned patients
                      </Button>
                    </div>
                  </>
                );
              } else if (this.state.currentPage === 5) {
                return (
                  <>
                    <Stepper
                      steps={[
                        { label: "Consent Collection" },
                        { label: "Aadhaar Authentication" },
                        { label: "Profile Verification" },
                        { label: "ABHA Address creation" },
                        { label: "View / Download ABHA" }
                      ]}
                      activeStep={0}
                      styleConfig={{
                        completedBgColor: "#30bd6d",
                        activeBgColor: "#39b54a"
                      }}
                      connectorStyleConfig={{
                        completedColor: "#30bd6d",
                        activeColor: "#39b54a"
                      }}
                    />
                    <div className="firstpage">
                      <FormGroup controlId="name" bsSize="medium">
                        <div className="row">
                          <div className="col-md-3 formfont">
                            Aadhaar Number
                          </div>
                          <div className="col-md-9">
                            <FormControl
                              autoFocus
                              required
                              type="text"
                              name="aadhaarNumber"
                              maxLength={12}
                              value={
                                this.state.maskedAadhaar ||
                                this.state.aadhaarNumber
                              }
                              onChange={this.onChange}
                              onBlur={this.handleAadhaarBlur}
                              onFocus={this.handleAadhaarFocus}
                            />
                          </div>
                        </div>
                      </FormGroup>
                      <FormGroup controlId="email" bsSize="large">
                        <div className="row">
                          <div className="col-md-3 formfont">Phone Number</div>
                          <div className="col-md-3">
                            <FormControl
                              required
                              type="text"
                              name="phoneNumber"
                              onChange={phoneNumber => {
                                this.setState({
                                  phoneNumber: phoneNumber.target.value,
                                  disableConsentButton:
                                    this.state.aadhaarNumber.length < 12 ||
                                    !this.state.consents.consent1 ||
                                    !this.state.consents.consent2 ||
                                    !this.state.consents.consent3 ||
                                    !this.state.consents.consent4 ||
                                    !this.state.consents.consent5 ||
                                    !this.state.consents.consent6 ||
                                    phoneNumber.target.value.length < 10
                                });
                              }}
                            />
                          </div>
                        </div>
                      </FormGroup>
                      <div className="termsandconditions">
                        <input
                          type="checkbox"
                          checked={this.state.consents.consent1}
                          onChange={e => {
                            this.setState({
                              consents: {
                                ...this.state.consents,
                                consent1: e.target.checked
                              },
                              disableConsentButton:
                                !e.target.checked ||
                                !this.state.consents.consent2 ||
                                !this.state.consents.consent3 ||
                                !this.state.consents.consent4 ||
                                !this.state.consents.consent5 ||
                                !this.state.consents.consent6 ||
                                this.state.aadhaarNumber.length < 12 ||
                                this.state.phoneNumber.length < 10
                            });
                          }}
                        />{" "}
                        I am voluntarily sharing my Aadhaar Number / Virtual ID
                        issued by the Unique Identification Authority of India
                        (&quot;UIDAI&quot;), and my demographic information for
                        the purpose of creating an Ayushman Bharat Health
                        Account number (&quot;ABHA number&quot;) and Ayushman
                        Bharat Health Account address (&quot;ABHA
                        Address&quot;). I authorize NHA to use my Aadhaar number
                        / Virtual ID for performing Aadhaar based authentication
                        with UIDAI as per the provisions of the Aadhaar
                        (Targeted Delivery of Financial and other Subsidies,
                        Benefits and Services) Act, 2016 for the aforesaid
                        purpose. I understand that UIDAI will share my e-KYC
                        details, or response of &quot;Yes&quot; with NHA upon
                        successful authentication.
                      </div>
                      <div className="termsandconditions">
                        <input
                          type="checkbox"
                          checked={this.state.consents.consent2}
                          onChange={e => {
                            this.setState({
                              consents: {
                                ...this.state.consents,
                                consent2: e.target.checked
                              },
                              disableConsentButton:
                                !this.state.consents.consent1 ||
                                !e.target.checked ||
                                !this.state.consents.consent3 ||
                                !this.state.consents.consent4 ||
                                !this.state.consents.consent5 ||
                                !this.state.consents.consent6 ||
                                this.state.aadhaarNumber.length < 12 ||
                                this.state.phoneNumber.length < 10
                            });
                          }}
                        />{" "}
                        I consent to usage of my ABHA address and ABHA number
                        for linking of my legacy (past) health records and those
                        which will be generated during this encounter.
                      </div>
                      <div className="termsandconditions">
                        <input
                          type="checkbox"
                          checked={this.state.consents.consent3}
                          onChange={e => {
                            this.setState({
                              consents: {
                                ...this.state.consents,
                                consent3: e.target.checked
                              },
                              disableConsentButton:
                                !this.state.consents.consent1 ||
                                !this.state.consents.consent2 ||
                                !e.target.checked ||
                                !this.state.consents.consent4 ||
                                !this.state.consents.consent5 ||
                                !this.state.consents.consent6 ||
                                this.state.aadhaarNumber.length < 12 ||
                                this.state.phoneNumber.length < 10
                            });
                          }}
                        />{" "}
                        I authorize the sharing of all my health records with
                        healthcare provider(s) for the purpose of providing
                        healthcare services to me during this encounter.
                      </div>
                      <div className="termsandconditions">
                        <input
                          type="checkbox"
                          checked={this.state.consents.consent6}
                          onChange={e => {
                            this.setState({
                              consents: {
                                ...this.state.consents,
                                consent6: e.target.checked
                              },
                              disableConsentButton:
                                !this.state.consents.consent1 ||
                                !this.state.consents.consent2 ||
                                !this.state.consents.consent3 ||
                                !this.state.consents.consent4 ||
                                !this.state.consents.consent5 ||
                                !this.target.checked ||
                                this.state.aadhaarNumber.length < 12 ||
                                this.state.phoneNumber.length < 10
                            });
                          }}
                        />{" "}
                        I consent to the anonymization and subsequent use of my
                        health records for public health purposes.
                      </div>
                      <div className="termsandconditions indented">
                        <input
                          type="checkbox"
                          checked={this.state.consents.consent4}
                          onChange={e => {
                            this.setState({
                              consents: {
                                ...this.state.consents,
                                consent4: e.target.checked
                              },
                              disableConsentButton:
                                !this.state.consents.consent1 ||
                                !this.state.consents.consent2 ||
                                !this.state.consents.consent3 ||
                                !e.target.checked ||
                                !this.state.consents.consent5 ||
                                !this.state.consents.consent6 ||
                                this.state.aadhaarNumber.length < 12 ||
                                this.state.phoneNumber.length < 10
                            });
                          }}
                        />{" "}
                        I, {sessionStorage.getItem("userName")}, confirm that I
                        have duly informed and explained the beneficiary of the
                        contents of consent for aforementioned purposes.
                      </div>
                      <div className="termsandconditions indented">
                        <input
                          type="checkbox"
                          checked={this.state.consents.consent5}
                          onChange={e => {
                            this.setState({
                              consents: {
                                ...this.state.consents,
                                consent5: e.target.checked
                              },
                              disableConsentButton:
                                !this.state.consents.consent1 ||
                                !this.state.consents.consent2 ||
                                !this.state.consents.consent3 ||
                                !this.state.consents.consent4 ||
                                !e.target.checked ||
                                !this.state.consents.consent6 ||
                                this.state.aadhaarNumber.length < 12 ||
                                this.state.phoneNumber.length < 10
                            });
                          }}
                        />{" "}
                        I have been explained about the consent as stated above
                        and hereby provide my consent for the aforementioned
                        purposes.
                      </div>
                      <Button
                        onClick={this.onSubmitConsent}
                        className="loginbtn1 create-account-btn submit-button"
                        disabled={this.state.disableConsentButton}
                      >
                        {this.state.isLoaded ? (
                          this.t(T_PATIENTS.addPatient.proceed)
                        ) : (
                          <img
                            src={require("../../assets/images/button-loading.gif")}
                          />
                        )}
                      </Button>
                    </div>
                  </>
                );
              } else if (this.state.currentPage === 6) {
                return (
                  <>
                    <Stepper
                      steps={[
                        { label: "Consent Collection" },
                        { label: "Aadhaar Authentication" },
                        { label: "Profile Verification" },
                        { label: "ABHA Address creation" },
                        { label: "View / Download ABHA" }
                      ]}
                      activeStep={1}
                      styleConfig={{
                        completedBgColor: "#30bd6d",
                        activeBgColor: "#39b54a"
                      }}
                      connectorStyleConfig={{
                        completedColor: "#30bd6d",
                        activeColor: "#39b54a"
                      }}
                    />
                    <p>Enter OTP</p>
                    <OtpInput
                      value={this.state.otp}
                      onChange={otp => {
                        this.setState({
                          otp: otp,
                          disableOtpButton: otp.length < 6
                        });
                      }}
                      name="otp"
                      numInputs={6}
                      renderSeparator={<span>&nbsp;</span>}
                      renderInput={props => <input {...props} />}
                      inputStyle="otpInput"
                    />
                    {(() => {
                      if (this.state.resendCount >= 2) {
                        return <></>;
                      } else {
                        if (this.state.isFinished) {
                          return (
                            <p className="resendOtp" onClick={this.resendOtp}>
                              Resend OTP (Attempts remaining:{" "}
                              {2 - this.state.resendCount}/2)
                            </p>
                          );
                        } else {
                          return (
                            <p className="resendOtpText">
                              You can send another OTP after{" "}
                              {this.state.timeLeft} seconds.
                            </p>
                          );
                        }
                      }
                    })()}
                    <Button
                      onClick={this.onSubmitOtp}
                      className="loginbtn1 create-account-btn submit-button"
                      disabled={this.state.disableOtpButton}
                    >
                      {this.state.isLoaded ? (
                        this.t(T_PATIENTS.addPatient.proceed)
                      ) : (
                        <img
                          src={require("../../assets/images/button-loading.gif")}
                        />
                      )}
                    </Button>
                  </>
                );
              } else if (this.state.currentPage === 7) {
                return (
                  <>
                    <Stepper
                      steps={[
                        { label: "Consent Collection" },
                        { label: "Aadhaar Authentication" },
                        { label: "Profile Verification" },
                        { label: "ABHA Address creation" },
                        { label: "View / Download ABHA" }
                      ]}
                      activeStep={1}
                      styleConfig={{
                        completedBgColor: "#30bd6d",
                        activeBgColor: "#39b54a"
                      }}
                      connectorStyleConfig={{
                        completedColor: "#30bd6d",
                        activeColor: "#39b54a"
                      }}
                    />
                    <p>Enter OTP</p>
                    <OtpInput
                      value={this.state.otp}
                      onChange={otp => {
                        this.setState({
                          otp: otp,
                          disableOtpButton: otp.length < 6
                        });
                      }}
                      name="otp"
                      numInputs={6}
                      renderSeparator={<span>&nbsp;</span>}
                      renderInput={props => <input {...props} />}
                      inputStyle="otpInput"
                    />
                    {(() => {
                      if (this.state.resendCount2 >= 2) {
                        return <></>;
                      } else {
                        if (this.state.isFinished) {
                          return (
                            <p className="resendOtp" onClick={this.resendOtp2}>
                              Resend OTP (Attempts remaining:{" "}
                              {2 - this.state.resendCount2}/2)
                            </p>
                          );
                        } else {
                          return (
                            <p className="resendOtpText">
                              You can send another OTP after{" "}
                              {this.state.timeLeft} seconds.
                            </p>
                          );
                        }
                      }
                    })()}
                    <Button
                      onClick={this.onSubmitOtp2}
                      className="loginbtn1 create-account-btn submit-button"
                      disabled={this.state.disableOtpButton}
                    >
                      {this.state.isLoaded ? (
                        this.t(T_PATIENTS.addPatient.proceed)
                      ) : (
                        <img
                          src={require("../../assets/images/button-loading.gif")}
                        />
                      )}
                    </Button>
                  </>
                );
              } else if (this.state.currentPage === 8) {
                return (
                  <>
                    <Stepper
                      steps={[
                        { label: "Consent Collection" },
                        { label: "Aadhaar Authentication" },
                        { label: "Profile Verification" },
                        { label: "ABHA Address creation" },
                        { label: "View / Download ABHA" }
                      ]}
                      activeStep={2}
                      styleConfig={{
                        completedBgColor: "#30bd6d",
                        activeBgColor: "#39b54a"
                      }}
                      connectorStyleConfig={{
                        completedColor: "#30bd6d",
                        activeColor: "#39b54a"
                      }}
                    />
                    <p>Please verify your details below:</p>
                    <p>
                      First Name:{" "}
                      <span className="aadhaarDetails">
                        {this.state.firstname}
                      </span>
                    </p>
                    <p>
                      Last Name:{" "}
                      <span className="aadhaarDetails">
                        {this.state.lastname}
                      </span>
                    </p>
                    <p>
                      Date of Birth:{" "}
                      <span className="aadhaarDetails">{this.state.dob}</span>
                    </p>
                    <p>
                      Address:{" "}
                      <span className="aadhaarDetails">
                        {this.state.address}
                      </span>
                    </p>
                    <p>
                      Phone Number:{" "}
                      <span className="aadhaarDetails">
                        {this.state.phoneNumber}
                      </span>
                    </p>
                    {(() => {
                      if (this.state.abhaNumber) {
                        return (
                          <p>
                            ABHA Number:{" "}
                            <span className="aadhaarDetails">
                              {this.state.abhaNumber}
                            </span>
                          </p>
                        );
                      }
                    })()}
                    <Button
                      onClick={this.goToAddressCreationPage}
                      className="loginbtn1 create-account-btn submit-button"
                      disabled={this.state.disableProfileButton}
                    >
                      {this.state.isLoaded ? (
                        this.t(T_PATIENTS.addPatient.proceed)
                      ) : (
                        <img
                          src={require("../../assets/images/button-loading.gif")}
                        />
                      )}
                    </Button>
                  </>
                );
              } else if (this.state.currentPage === 9) {
                return (
                  <>
                    <Stepper
                      steps={[
                        { label: "Consent Collection" },
                        { label: "Aadhaar Authentication" },
                        { label: "Profile Verification" },
                        { label: "ABHA Address creation" },
                        { label: "View / Download ABHA" }
                      ]}
                      activeStep={3}
                      styleConfig={{
                        completedBgColor: "#30bd6d",
                        activeBgColor: "#39b54a"
                      }}
                      connectorStyleConfig={{
                        completedColor: "#30bd6d",
                        activeColor: "#39b54a"
                      }}
                    />
                    {(() => {
                      if (this.state.predefinedAbhaAddress) {
                        return (
                          <>
                            <Button
                              onClick={() => {
                                this.setState({
                                  abhaAddress: this.state.predefinedAbhaAddress
                                });
                                this.goToNextPage();
                                postAuthenticatedData(
                                  sessionStorage.getItem("domain") +
                                    getAbhaCard +
                                    "?abhaAddressAuthentication=" +
                                    (this.state.method ===
                                      "abhaAddressViaAbha" ||
                                    this.state.method ===
                                      "abhaAddressViaAadhaar"
                                      ? "true"
                                      : "false"),
                                  { token: this.state.token }
                                )
                                  .then(res2 => res2.json())
                                  .then(res2 => {
                                    if (res2.status.statusCode === "OK") {
                                      this.setState({
                                        abhaImage: res2.data,
                                        abhaCardAvailable: true,
                                        abhaCardError: false
                                      });
                                    } else {
                                      this.setState({
                                        abhaCardAvailable: false,
                                        abhaCardError: true,
                                        abhaImage: ""
                                      });
                                    }
                                  });
                              }}
                              className="loginbtn1 use-existing-btn"
                              disabled={this.state.disableAbhaAddressButton}
                            >
                              Use existing ABHA Address
                            </Button>
                            <div className="separator">
                              <div className="line"></div>
                              <span className="or-text">OR</span>
                              <div className="line"></div>
                            </div>
                          </>
                        );
                      }
                    })()}
                    <p>Choose an ABHA Address</p>
                    <FormGroup controlId="email" bsSize="large">
                      <div className="row input-email">
                        <div className="col-md-3 formfont">ABHA Address</div>
                        <div className="col-md-3">
                          <FormControl
                            required
                            type="text"
                            name="abhaAddress"
                            value={this.state.abhaAddress?.split("@abdm")[0]}
                            onChange={this.onChange}
                          />
                        </div>
                        <div className="col-md-6 domain-name">@abdm</div>
                      </div>
                      <AbhaAddressValidation />
                    </FormGroup>
                    {this.state.abhaAddressList.length > 0 ? (
                      <>
                        <p>Suggested ABHA addresses:</p>
                        <div className="abha-suggestions">
                          <div
                            className="abha-suggestion"
                            onClick={() => {
                              const value = this.state.abhaAddressList[0];
                              const validation = this.validateAbhaAddress(
                                value
                              );
                              this.setState({
                                abhaAddress: value + "@abdm",
                                abhaAddressValidation: validation,
                                disableAbhaAddressButton: !validation.isValid
                              });
                            }}
                          >
                            {this.state.abhaAddressList[0]}
                          </div>
                          {this.state.abhaAddressList[1] ? (
                            <div
                              className="abha-suggestion"
                              onClick={() => {
                                const value = this.state.abhaAddressList[1];
                                const validation = this.validateAbhaAddress(
                                  value
                                );
                                this.setState({
                                  abhaAddress: value + "@abdm",
                                  abhaAddressValidation: validation,
                                  disableAbhaAddressButton: !validation.isValid
                                });
                              }}
                            >
                              {this.state.abhaAddressList[1]}
                            </div>
                          ) : (
                            <></>
                          )}
                          {this.state.abhaAddressList[2] ? (
                            <div
                              className="abha-suggestion"
                              onClick={() => {
                                const value = this.state.abhaAddressList[2];
                                const validation = this.validateAbhaAddress(
                                  value
                                );
                                this.setState({
                                  abhaAddress: value + "@abdm",
                                  abhaAddressValidation: validation,
                                  disableAbhaAddressButton: !validation.isValid
                                });
                              }}
                            >
                              {this.state.abhaAddressList[2]}
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                    <Button
                      onClick={this.enrollAbha}
                      className="loginbtn1 create-account-btn submit-button"
                      disabled={this.state.disableAbhaAddressButton}
                    >
                      {this.state.isLoaded ? (
                        "Submit"
                      ) : (
                        <img
                          src={require("../../assets/images/button-loading.gif")}
                        />
                      )}
                    </Button>
                  </>
                );
              } else if (this.state.currentPage === 10) {
                return (
                  <>
                    <Stepper
                      steps={[
                        { label: "Consent Collection" },
                        { label: "Aadhaar Authentication" },
                        { label: "Profile Verification" },
                        { label: "ABHA Address creation" },
                        { label: "View / Download ABHA" }
                      ]}
                      activeStep={4}
                      styleConfig={{
                        completedBgColor: "#30bd6d",
                        activeBgColor: "#39b54a"
                      }}
                      connectorStyleConfig={{
                        completedColor: "#30bd6d",
                        activeColor: "#39b54a"
                      }}
                    />
                    {this.state.abhaCardAvailable ? (
                      <>
                        <img
                          src={this.state.abhaImage}
                          className="abha-image"
                        />
                        <div className="abha-card-actions">
                          <Button
                            onClick={this.downloadAbha}
                            className="loginbtn1 create-account-btn submit-button abha-card-action"
                          >
                            Download ABHA Card
                          </Button>
                          <Button
                            onClick={this.printAbha}
                            className="loginbtn1 create-account-btn submit-button abha-card-action"
                          >
                            Print ABHA Card
                          </Button>
                        </div>
                      </>
                    ) : (
                      <div className="abha-card-error">
                        {this.state.abhaCardError && (
                          <p className="error-message">
                            ABHA Card could not be loaded at this time.
                          </p>
                        )}
                      </div>
                    )}
                    <Button
                      onClick={this.returnToFirstPage}
                      className="loginbtn1 create-account-btn submit-button"
                    >
                      Finish
                    </Button>
                  </>
                );
              } else if (this.state.currentPage === 11) {
                return (
                  <>
                    {(() => {
                      if (this.state.method === "phoneNumber") {
                        return (
                          <Stepper
                            steps={[
                              { label: "Choose Method of Authentication" },
                              { label: "Select account" },
                              { label: "Verify OTP" }
                            ]}
                            activeStep={0}
                            styleConfig={{
                              completedBgColor: "#30bd6d",
                              activeBgColor: "#39b54a"
                            }}
                            connectorStyleConfig={{
                              completedColor: "#30bd6d",
                              activeColor: "#39b54a"
                            }}
                          />
                        );
                      } else {
                        return (
                          <Stepper
                            steps={[
                              { label: "Choose Method of Authentication" },
                              { label: "Verify OTP" },
                              { label: "Select account" }
                            ]}
                            activeStep={0}
                            styleConfig={{
                              completedBgColor: "#30bd6d",
                              activeBgColor: "#39b54a"
                            }}
                            connectorStyleConfig={{
                              completedColor: "#30bd6d",
                              activeColor: "#39b54a"
                            }}
                          />
                        );
                      }
                    })()}
                    <p>Choose mode of authentication</p>
                    <select
                      name="verify-method"
                      className="verifyMethod"
                      onChange={this.changeMethod}
                    >
                      <option value="phoneNumber">Phone Number</option>
                      <option value="abhaNumberViaAbha">
                        ABHA Number via Mobile OTP
                      </option>
                      <option value="abhaNumberViaAadhaar">
                        ABHA Number via Aadhaar OTP
                      </option>
                      <option value="abhaAddress">ABHA Address</option>
                      <option value="aadhaarNumber">Aadhaar Number</option>
                    </select>

                    {this.state.method === "phoneNumber" && (
                      <>
                        <FormGroup controlId="email" bsSize="large">
                          <div className="row">
                            <div className="col-md-3 formfont">
                              Phone Number
                            </div>
                            <div className="col-md-3">
                              <FormControl
                                required
                                type="text"
                                name="phoneNumber"
                                onChange={this.onChange}
                                maxLength={10}
                                inputMode="numeric"
                                value={this.state.phoneNumber}
                              />
                            </div>
                          </div>
                        </FormGroup>
                      </>
                    )}
                    {(this.state.method === "abhaNumberViaAbha" ||
                      this.state.method === "abhaNumberViaAadhaar") && (
                      <>
                        <FormGroup controlId="email" bsSize="large">
                          <div className="row">
                            <div className="col-md-3 formfont">ABHA Number</div>
                            <div className="col-md-3">
                              <FormControl
                                required
                                type="text"
                                name="abhaNumber"
                                onChange={this.onChange}
                                maxLength={17}
                                value={this.state.abhaNumber}
                              />
                            </div>
                          </div>
                        </FormGroup>
                      </>
                    )}
                    {(this.state.method === "abhaAddressViaAbha" ||
                      this.state.method === "abhaAddressViaAadhaar" ||
                      this.state.method === "abhaAddress") && (
                      <>
                        <FormGroup controlId="email" bsSize="large">
                          <div className="row">
                            <div className="col-md-3 formfont">
                              ABHA Address
                            </div>
                            <div className="col-md-3">
                              <FormControl
                                required
                                type="text"
                                name="abhaAddress"
                                onChange={this.onChange}
                                maxLength={22}
                                value={this.state.abhaAddress}
                              />
                            </div>
                          </div>
                        </FormGroup>
                      </>
                    )}
                    {this.state.method === "aadhaarNumber" && (
                      <>
                        <FormGroup controlId="email" bsSize="large">
                          <div className="row">
                            <div className="col-md-3 formfont">
                              Aadhaar Number
                            </div>
                            <div className="col-md-3">
                              <FormControl
                                required
                                type="text"
                                name="aadhaarNumber"
                                onChange={this.onChange}
                                onBlur={this.handleAadhaarBlur}
                                maxLength={12}
                                value={this.state.aadhaarNumber}
                              />
                            </div>
                          </div>
                        </FormGroup>
                      </>
                    )}
                    {this.state.couldBeUnlinked ? (
                      <p
                        className="small-abha"
                        onClick={() => this.setState({ currentPage: 5 })}
                      >
                        Create a new ABHA Address instead?
                      </p>
                    ) : (
                      <></>
                    )}
                    {this.state.authModesFetched &&
                      this.state.method.includes("abhaAddress") && (
                        <div className="authmodes">
                          <p>Choose Method of Authentication:</p>
                          {this.state.authModes.includes("MOBILE_OTP") && (
                            <label>
                              <input
                                type="radio"
                                name="authMethod"
                                value="abha"
                                onChange={this.handleAuthChange}
                                checked={
                                  this.state.method === "abhaAddressViaAbha"
                                }
                              />
                              Via Mobile OTP
                            </label>
                          )}
                          {this.state.authModes.includes("AADHAAR_OTP") && (
                            <label>
                              <input
                                type="radio"
                                name="authMethod"
                                value="aadhaar"
                                onChange={this.handleAuthChange}
                                checked={
                                  this.state.method === "abhaAddressViaAadhaar"
                                }
                              />
                              Via Aadhaar OTP
                            </label>
                          )}
                        </div>
                      )}
                    <Button
                      onClick={this.nextStepLinking}
                      className="loginbtn1 create-account-btn submit-button verify-first-button"
                      disabled={this.state.disableVerifyButton}
                    >
                      {this.state.isLoaded ? (
                        "Proceed"
                      ) : (
                        <img
                          src={require("../../assets/images/button-loading.gif")}
                        />
                      )}
                    </Button>
                  </>
                );
              } else if (this.state.currentPage === 12) {
                return (
                  <>
                    {(() => {
                      if (this.state.method === "phoneNumber") {
                        return (
                          <Stepper
                            steps={[
                              { label: "Choose Method of Authentication" },
                              { label: "Select account" },
                              { label: "Verify OTP" }
                            ]}
                            activeStep={2}
                            styleConfig={{
                              completedBgColor: "#30bd6d",
                              activeBgColor: "#39b54a"
                            }}
                            connectorStyleConfig={{
                              completedColor: "#30bd6d",
                              activeColor: "#39b54a"
                            }}
                          />
                        );
                      } else {
                        return (
                          <Stepper
                            steps={[
                              { label: "Choose Method of Authentication" },
                              { label: "Verify OTP" },
                              { label: "Select account" }
                            ]}
                            activeStep={1}
                            styleConfig={{
                              completedBgColor: "#30bd6d",
                              activeBgColor: "#39b54a"
                            }}
                            connectorStyleConfig={{
                              completedColor: "#30bd6d",
                              activeColor: "#39b54a"
                            }}
                          />
                        );
                      }
                    })()}
                    <p>Enter OTP</p>
                    <OtpInput
                      value={this.state.otp}
                      onChange={otp => {
                        this.setState({
                          otp: otp,
                          disableOtpButton: otp.length < 6
                        });
                      }}
                      name="otp"
                      numInputs={6}
                      renderSeparator={<span>&nbsp;</span>}
                      renderInput={props => <input {...props} />}
                      inputStyle="otpInput"
                    />
                    {(() => {
                      if (this.state.resendCountVerify >= 2) {
                        return <></>;
                      } else {
                        if (this.state.isFinished) {
                          return (
                            <p
                              className="resendOtp"
                              onClick={this.resendOtpVerify}
                            >
                              Resend OTP (Attempts remaining:{" "}
                              {2 - this.state.resendCountVerify}/2)
                            </p>
                          );
                        } else {
                          return (
                            <p className="resendOtpText">
                              You can send another OTP after{" "}
                              {this.state.timeLeft} seconds.
                            </p>
                          );
                        }
                      }
                    })()}
                    <Button
                      onClick={this.onSubmitOtpVerify}
                      className="loginbtn1 create-account-btn submit-button"
                      disabled={this.state.disableOtpButton}
                    >
                      {this.state.isLoaded ? (
                        this.t(T_PATIENTS.addPatient.proceed)
                      ) : (
                        <img
                          src={require("../../assets/images/button-loading.gif")}
                        />
                      )}
                    </Button>
                  </>
                );
              } else if (this.state.currentPage === 13) {
                return (
                  <>
                    <Stepper
                      steps={[
                        { label: "Choose Method of Authentication" },
                        { label: "Verify OTP" },
                        { label: "Select account" }
                      ]}
                      activeStep={2}
                      styleConfig={{
                        completedBgColor: "#30bd6d",
                        activeBgColor: "#39b54a"
                      }}
                      connectorStyleConfig={{
                        completedColor: "#30bd6d",
                        activeColor: "#39b54a"
                      }}
                    />
                    <p>Select an account:</p>
                    {this.state.accountsVerify.map((account, index) => (
                      <div
                        onClick={() => {
                          this.setState({
                            selectedAccountVerify: index,
                            disableSubmitAccountVerifyButton: false
                          });
                        }}
                        className={`verify-select-container ${
                          this.state.selectedAccountVerify === index
                            ? "selected"
                            : ""
                        }`}
                        key={index}
                      >
                        <img
                          src={this.state.abhaImage}
                          className="abha-image"
                        />
                        <p>
                          <span className="verify-heading">Name: </span>
                          {account.name || account.fullName}
                        </p>
                        <p>
                          <span className="verify-heading">Gender: </span>
                          {account.gender}
                        </p>
                        <p>
                          <span className="verify-heading">
                            Date of Birth:{" "}
                          </span>
                          {this.state.method === "phoneNumber"
                            ? account.dob
                            : account.dayOfBirth +
                              "-" +
                              account.monthOfBirth +
                              "-" +
                              account.yearOfBirth}
                        </p>
                        <p>
                          <span className="verify-heading">ABHA Number: </span>
                          {account.ABHANumber || account.abhaNumber}
                        </p>
                        <p>
                          <span className="verify-heading">ABHA Address: </span>
                          {account.preferredAbhaAddress || account.abhaAddress}
                        </p>
                        <p>
                          <span className="verify-heading">Phone Number: </span>
                          {account.mobile ||
                            account.phoneNumber ||
                            this.state.phoneNumber}
                        </p>
                        <p>
                          <span className="verify-heading">Address: </span>
                          {account.address}
                        </p>
                        <p>
                          <span className="verify-heading">District: </span>
                          {account.districtName}
                        </p>
                        <p>
                          <span className="verify-heading">State: </span>
                          {account.stateName}
                        </p>
                        <p>
                          <span className="verify-heading">PIN Code: </span>
                          {account.pincode || account.pinCode}
                        </p>
                        {this.state.abhaCardAvailable && (
                          <Button
                            onClick={() => this.downloadAbha()}
                            className="create-account-btn download-abha-btn"
                          >
                            Download ABHA Card
                          </Button>
                        )}
                      </div>
                    ))}

                    <Button
                      onClick={this.onSubmitAccountVerify}
                      className="loginbtn1 create-account-btn submit-button"
                      disabled={this.state.disableSubmitAccountVerifyButton}
                    >
                      {this.state.isLoaded ? (
                        this.t(T_PATIENTS.addPatient.proceed)
                      ) : (
                        <img
                          src={require("../../assets/images/button-loading.gif")}
                        />
                      )}
                    </Button>
                  </>
                );
              } else if (this.state.currentPage === 14) {
                return (
                  <>
                    <FormGroup controlId="email" bsSize="large">
                      <div className="row site-verify">
                        <div className="col-md-3 formfont">
                          {this.t(T_ENTITIES.patient.site)}*
                        </div>
                        <div className="col-md-9">
                          <select
                            name="site"
                            onChange={this.onChangeSite}
                            value={this.state.site}
                          >
                            {this.props.sites?.map?.(e => (
                              <option value={e?.siteId} key={e?.siteId}>
                                {e?.siteName}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </FormGroup>
                    {(() => {
                      if (this.state.scanAccounts.length === 0) {
                        return (
                          <p>There are no check in patients for this site.</p>
                        );
                      } else {
                        return (
                          <div className="table-container">
                            <Table className="tablebox">
                              <thead>
                                <tr>
                                  <th>Name</th>
                                  <th>Gender</th>
                                  <th>MRN</th>
                                  <th>Date of Birth</th>
                                  <th>Site</th>
                                  <th>Token Number</th>
                                  <th>Check In Time</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.scanAccounts?.map?.(
                                  (item, index) => (
                                    <tr key={item.id}>
                                      <td id={"dName" + item.userId}>
                                        <a
                                          onClick={() => {
                                            this.onScanEnd(index);
                                          }}
                                        >
                                          <span className="editbtn">
                                            {item?.name}
                                          </span>
                                        </a>
                                      </td>
                                      <td className="patient-gender">
                                        {item?.gender === "M"
                                          ? "Male"
                                          : "Female"}
                                      </td>
                                      <td>{item?.abhaNumber}</td>
                                      <td>
                                        {item?.dayOfBirth}{" "}
                                        {getShortMonth(item?.monthOfBirth - 1)}{" "}
                                        {item?.yearOfBirth}
                                      </td>
                                      <td>{item?.site?.siteName}</td>
                                      <td>{item?.tokenNumber}</td>
                                      <td>
                                        {convertEpochToTime(item?.checkInTime)}
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </Table>
                          </div>
                        );
                      }
                    })()}
                  </>
                );
              } else if (this.state.currentPage === 15) {
                return (
                  <>
                    <Stepper
                      steps={[
                        { label: "Choose Method of Authentication" },
                        { label: "Select account" },
                        { label: "Verify OTP" }
                      ]}
                      activeStep={1}
                      styleConfig={{
                        completedBgColor: "#30bd6d",
                        activeBgColor: "#39b54a"
                      }}
                      connectorStyleConfig={{
                        completedColor: "#30bd6d",
                        activeColor: "#39b54a"
                      }}
                    />
                    <p>Select an account:</p>
                    {this.state.accountsVerify.map((account, index) => (
                      <div
                        onClick={() => {
                          this.setState({
                            selectedAccountVerify: index,
                            disableSubmitAccountVerifyButton: false
                          });
                        }}
                        className={`verify-select-container ${
                          this.state.selectedAccountVerify === index
                            ? "selected"
                            : ""
                        }`}
                        key={index}
                      >
                        <p>
                          <span className="verify-heading">Name: </span>
                          {account.name || account.fullName}
                        </p>
                        <p>
                          <span className="verify-heading">Gender: </span>
                          {account.gender}
                        </p>
                        <p>
                          <span className="verify-heading">ABHA Number: </span>
                          {account.ABHANumber || account.abhaNumber}
                        </p>
                      </div>
                    ))}

                    <Button
                      onClick={this.onSubmitAccountVerify}
                      className="loginbtn1 create-account-btn submit-button"
                      disabled={this.state.disableSubmitAccountVerifyButton}
                    >
                      {this.state.isLoaded ? (
                        this.t(T_PATIENTS.addPatient.proceed)
                      ) : (
                        <img
                          src={require("../../assets/images/button-loading.gif")}
                        />
                      )}
                    </Button>
                  </>
                );
              } else if (this.state.currentPage === 16) {
                const original = this.state.originalPatientData;
                const newData = this.state.newPatientData;

                return (
                  <>
                    <div className="comparison-header">
                      <h5>Patient Data Comparison</h5>
                      <p>
                        An existing patient was found with this MRN. Please
                        choose which data to use:
                      </p>
                    </div>

                    <div className="comparison-container">
                      <div className="comparison-column">
                        <h6 className="comparison-title">
                          Existing Patient Data
                        </h6>
                        <div className="comparison-data">
                          <p>
                            <strong>MRN:</strong> {original.mrn}
                          </p>
                          <p>
                            <strong>First Name:</strong> {original.firstName}
                          </p>
                          <p>
                            <strong>Last Name:</strong> {original.lastName}
                          </p>
                          <p>
                            <strong>Gender:</strong> {original.gender}
                          </p>
                          <p>
                            <strong>Date of Birth:</strong>{" "}
                            {new Date(
                              original.dateOfBirth
                            ).toLocaleDateString()}
                          </p>
                          <p>
                            <strong>Phone Number:</strong>{" "}
                            {original.phoneNumber || "Not Available"}
                          </p>
                          <p>
                            <strong>ABHA Number:</strong>{" "}
                            {original.abhaNumber || "Not Available"}
                          </p>
                          <p>
                            <strong>ABHA Address:</strong>{" "}
                            {original.abhaAddress || "Not Available"}
                          </p>
                          <p>
                            <strong>Address:</strong>{" "}
                            {original.address || "Not Available"}
                          </p>
                          <p>
                            <strong>District:</strong>{" "}
                            {original.district || "Not Available"}
                          </p>
                          <p>
                            <strong>State:</strong>{" "}
                            {original.state || "Not Available"}
                          </p>
                          <p>
                            <strong>PIN Code:</strong>{" "}
                            {original.pinCode || "Not Available"}
                          </p>
                        </div>
                      </div>

                      <div className="comparison-column">
                        <h6 className="comparison-title">New ABHA Data</h6>
                        <div className="comparison-data">
                          <p>
                            <strong>MRN:</strong> {newData.mrn}
                          </p>
                          <p>
                            <strong>First Name:</strong> {newData.firstName}
                          </p>
                          <p>
                            <strong>Last Name:</strong> {newData.lastName}
                          </p>
                          <p>
                            <strong>Gender:</strong> {newData.gender}
                          </p>
                          <p>
                            <strong>Date of Birth:</strong>{" "}
                            {new Date(newData.dateOfBirth).toLocaleDateString()}
                          </p>
                          <p>
                            <strong>Phone Number:</strong> {newData.phoneNumber}
                          </p>
                          <p>
                            <strong>ABHA Number:</strong> {newData.abhaNumber}
                          </p>
                          <p>
                            <strong>ABHA Address:</strong> {newData.abhaAddress}
                          </p>
                          <p>
                            <strong>Address:</strong> {newData.address}
                          </p>
                          <p>
                            <strong>District:</strong> {newData.district}
                          </p>
                          <p>
                            <strong>State:</strong> {newData.state}
                          </p>
                          <p>
                            <strong>PIN Code:</strong> {newData.pinCode}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="comparison-actions">
                      <Button
                        onClick={this.keepOriginalData}
                        className="loginbtn1 create-account-btn submit-button keep-button"
                      >
                        Keep Existing Patient Data
                      </Button>
                      <Button
                        onClick={this.acceptNewPatientData}
                        className="loginbtn1 create-account-btn submit-button accept-button"
                      >
                        Use New ABHA Data
                      </Button>
                    </div>
                  </>
                );
              }
            })()}
          </form>
        </div>
      </div>
    );
  }
}

export default withTranslation()(CustomAddExamPatientModal);
